﻿export const lng: object = {
  phGlobal_OpenTime: "Opening Time",
  phGlobal_Pickup_openTime: "Takeaway Time",
  phGlobal_Delivery_openTime: "Delivery Time",
  phGlobal_InHouse_openTime: "Ordering Time",
  phGlobal_Return: "Return",
  phGlobal_Continue: "Continue",
  phGlobal_Sum: "Sum",
  phGlobal_Discount: "Discount",
  phGlobal_Total: "Total",
  phGlobal_Deposit: "Deposit",
  phGlobal_DeliveryFee: "Delivery Charge",

  phGender_None: " ",
  phGender_Woman: "Female",
  phGender_Man: "Male",
  phGender_Divers: "Divers",

  phPrefix_Man: "Mr",
  phPrefix_Woman: "Ms",
  phPrefix_Divers: "Mx",

  phOfflineIndicator_NoConnection: "No Connection",
  phOfflineIndicator_BackOnline: "Back Online",

  phUser_Credit: "Credit",
  phUser_Discount: "Discount",
  phUser_InvitationAmount: "Invitation Amount",

  phEmptyTab_Title: "Sorry!",
  phEmptyTab_Content: "Unfortunately, there is currently nothing to see here. Please check back soon.",

  phEmptyTab_Tickets_Title: "Sorry!",
  phEmptyTab_Tickets_Info: "There are currently no tickets available for this date.",

  phEmptyPage_Title: "Sorry",
  phEmptyPage_Message: "There's nothing to see here at the moment. Check back soon and check your filter settings so that you can see all the content you are interested in.",

  phEmpty_UserLike_Page_Title: "No Likes yet?",
  phEmpty_UserLike_Page_Content: "Here you will find all the content that you have marked with a 'Like' (heart) in the app, so that you can quickly find it again at any time. Try it out right now!",

  phErrorMessage_Title: "Sorry...",
  phErrorMessage_Text: "Unfortunately, we could not process your request.<br>Please try again later.",
  phErrorMessage_Text_Checkout: "The order process could not be completed.<br>Please try again later.",
  phErrorMessage_Text_ResetBasket: "Unfortunately, a technical problem occurred while processing the shopping basket.<br>We have already corrected the error and ask you to place the order again.<br>Thank you for your understanding.",
  phErrorMessage_Button: "Ok",
  phErrorMessage_Title_MultipleOrder: "Attention",
  phErrorMessage_Text_MultipleOrder: "Your Order was already succesfully placed. Please check your mails for the confirmation.",

  phDeliverAddressNotDestination_Title: "Sorry...",
  phDeliverAddressNotDestination_Zip_Text: "The postal code does not match the previously selected delivery address \"{zip}\".",
  phDeliverAddressNotDestination_ZipAndCity_Text: "The address does not match the previously selected delivery address \"{zip}, {city}\".",

  phLogin_Title: "Registration",
  phLogin_PlaceholderEMail: "E-Mail",
  phLogin_PlaceholderPassword: "Password",
  phLogin_ForgotPassword: "Password forgotten?",
  phLogin_LogIn: "Log In",
  phLogin_NotAMember: "Not registered yet?",
  phLogin_Message: "Please check Your entries:",
  phLogin_MessageErrorLogin_UnknownReason: "Login could not be done. Please try again later.",
  phLogin_MessageErrorLogin_NoEmailGiven: "Please enter an e-mail.",
  phLogin_MessageErrorLogin_NoPasswordGiven: "Please enter a password.",
  phLogin_MessageErrorAuth_InvalidEmail: "The e-mail address is formatted incorrectly.",
  phLogin_MessageErrorAuth_UserDisabled: "Registration is not possible at this time.",
  phLogin_MessageErrorAuth_UserNotFound: "Login details unknown.",
  phLogin_MessageErrorAuth_WrongPassword: "Login details unknown.",
  phLogin_PasswordResetEmailSend: "An e-mail with further Instructions was sent to your e-mail <email>.",

  phMainNav_SideMenuHeader: "Menu",
  phMainNav_AboutUs: "About us",
  phMainNav_More: "More",
  phMainNav_Home: "Start",
  phMainNav_Paymentoptions: "Payment options",
  phMainNav_Service: "Service",
  phMainNav_Legal: "Legal",
  phMainNav_Language: "Language",
  phMainNav_Community: "Community",
  phMainNav_CopyRight: "All rights reserved",

  phRatingDialog_SendRate: "Send",
  phRatingDialog_Characters_Available: "Remaining characters",
  phRatingDialog_Validation_Message: "You must first check the stars",

  phFilterLayer_Title: "Select location",
  phFilterLayer_Description: "Filter additional locations to temporarily show more information. Under locations you can \"like\" these permanently.",
  phFilterLayer_Filter: "Filters",

  phLoginDialog_Login: "Log In",
  phLoginDialog_Register: "Register Now",

  phLanguageDialog_Title: "Choose Language",
  phLanguageDialog_lang_de: "German",
  phLanguageDialog_lang_en: "English",

  phLocation_TabName_LocationList: "List",
  phLocation_TabName_Map: "Map",
  phLocation_Search_Location: "Search location",

  phLocationDetail_Route: "Your way to us",
  phLocationDetail_Reservation: "Reservation",
  phLocationDetail_Info_Title: "Address & Contact",
  phLocationDetail_TabName_Overview: "Overview",
  phLocationDetail_TabName_Order: "Order",
  phLocationDetail_PlsChooseService_TEXT: "Please select how you would like to order from us.",
  phLocationDetail_DeviatingOpeningHours: "Deviating opening hours",

  phEvent_TabName_Upcomming: "Upcoming",
  phEvent_TabName_Expired: "Expired",

  phEventDetail_Date: "Date: ",
  phEventDetail_Time: "Time: ",
  phEventDetail_From: "From: ",
  phEventDetail_To: "To: ",
  phEventDetail_Location: "Participating locations:",

  phSnackBarMessages: {
    successfullyExecuted: "Successfully executed",
    unkownLocation: "Location cannot be determined",
    failed: "Failed",
    locationNotFound: "No locations found",
    UpdateFailed: "Update failed",
    deviceOffline: "Your device is offline!",
    deviceOnline: "Your device is online!",
    unsupported: "Your device is not supported!",
    scanAgain: "Scan again",
    copiedToClipboard: "Copied to Clipboard",
    userJoinedTheGroup: "{userName} has joined the group",
    userLeftTheGroup: "{userName} left the group",
    allMembersAreReady: "All members are ready",
    accountPaymentSuccess: "Request sent",
    accountPaymentError: "Request could not be sent",
    retailDeliveryCountryMissing: "Please select a valid delivery country so we can calculate the shipping cost.",
  },

  phCounter_UnitNames: {
    Days: "Days",
    Hours: "Hours",
    Minutes: "Minutes",
    Seconds: "Seconds"
  },

  phUserLike_ContentType: {
    News: "News",
    Coupon: "Coupons",
    Event: "Events",
    Location: "Location",
    Aktion: "Action",
    Menu: "Menu",
    Bonussystem: "Bonus Action"
  },

  phRegistration_Title: "Welcome",
  phRegistr_Tab_Title: "Register now for free to collect points, get discounts and enjoy many other benefits.",
  phRegistration_TabName_Register: "Register",
  phRegistration_TabName_Login: "Log In",
  phRegistration_LoginTab_ForgetPassword: "Password forgotten?",
  phRegistration_RegisterTab_Registerbutton: "Register",
  phRegistration_LoginTab_LoginButton: "Log In",
  phRegisteration_Validate_Email: "The E-Mail address is formatted incorrectly",
  phRegisteration_Validate_Password: "Your password must consists of 8 characters, at least one letter and one number.",
  phRegisteration_ForgetPassword_Message: "We have sent you an e-mail to reset your password. If you haven't received an e-mail, please check your spam folder or click on \"Request Again\"",
  phRegistration_ForgetPassword_RequestAgain: "Request Again",
  phRegistration_CheckPrivacy_Error: "Please confirm our legal texts",
  phRegistration_Email_PlaceHolder: "E-Mail",
  phRegistration_Password_PlaceHolder: "Password",
  phRegistration_GoogleRegistration_Button: "Continue with Google",
  phRegistration_FacebookRegistration_Button: "Continue with Facebook",
  phRegistration_ThirdPartyRegistration_Seperator: "or continue with",
  phRegistration_ThirdPartyLogin_Seperator: "or login with",

  phRegister_Failed_message: "The E-Mail <email> is already registered. Please log in via the login page.",
  phLogin_Failed_message: "The user name or password is incorrect.",

  phLoginActivation_Title: "Welcome",
  phLogin_Tab_Title: "Already registered? Great!<phloginTitleBreak>Sign up here with your access data and enjoy many other advantages immediately.",
  phLoginActivation_TitleMessage: "Immediately done!",
  phLoginActivation_ResetPassword: "Resend activation E-Mail",
  phLoginActivation_Continue: "Continue",
  phLoginActivation_Login_Title: "Log In",
  phLoginActivation_ForgetPassword: "Password forgotten?",
  phLoginActivation_MainMessage: "Please confirm your registration in the e-mail we sent to <email>",
  phLoginActivation_Failed_Message: "The E-Mail <email> has not yet been activated. Please check your inbox.",

  phForgetPassword_Title: "Password forgotten?",
  phForgetPassword_Message: "Enter your E-Mail so we can reset your password.",
  phForgetPassword_ResetPassword: "Password reset",
  phForgetPassword_ValidationMessage: "Sorry! That didn't work, please check your entry.",
  phForgetPassword_Email_PlaceHolder: "E-Mail",

  phRegistrationData_Title: "Welcome",
  phRegistrationData_Label_Name: "Your First Name",
  phRegistrationData_Name_PlaceHolder: "Your First Name",
  phRegistrationData_Location_Select: "Choose your favorite locations",
  phRegistrationData_Location_Button: "Select locations",
  phRegistrationData_SelectedLocation_Button: "Location selected",
  phRegistrationData_MultipleSelectedLocation_Button: "Locations selected",
  phRegistrationData_Register_Button: "Register",
  phRegistrationData_Location_Validation_Error: "Please select at least one location",
  phRegistrationData_Name_Validation_Error: "The first name can not be empty.",

  phRegistrationInput_prefix: "Title",
  phRegistrationInput_name: "Last Name",
  phRegistrationInput_fname: "First Name",
  phRegistrationInput_companyAddress: "Company Address",
  phRegistrationInput_co: "C/O",
  phRegistrationInput_address: "Street & House Number",
  phRegistrationInput_addition: "Additional Address Info",
  phRegistrationInput_zip_code: "Postal Code",
  phRegistrationInput_city: "City",
  phRegistrationInput_country: "Country",
  phRegistrationInput_email: "Email",
  phRegistrationInput_password: "Password",
  phRegistrationInput_telephone1: "Private Phone",
  phRegistrationInput_telephone2: "Business Phone",
  phRegistrationInput_telephone_mobile: "Mobile Phone",

  phDataInputs_Default_MaxLength: "Please enter a maximum of {length} characters.",
  phDataInputs_Default_MinLength: "Please enter at least {length} characters.",
  phDataInputs_Default_Validate_Letters_Pattern: "Please enter letters only.",
  phDataInputs_Default_Validate_NumbersOnly: "Please enter numbers only.",
  phDataInputs_Default_Validate_required: "This field can not be empty.",
  phDataInputs_Name_Validate_Required: "The name can not be empty.",
  phDataInputs_Lastname_Validate_Required: "The last name can not be empty.",
  phDataInputs_Gender_Validate_Required: "The gender can not be empty.",
  phDataInputs_Street_Required: "The street can not be empty.",
  phDataInputs_Street_Pattern: "The street is invalid.",
  phDataInputs_House_Number_Pattern: "The house number is invalid.",
  phDataInputs_Address_Validate_Required: "The address can not be empty.",
  phDataInputs_Address_Validate_Pattern: "Please enter street and house number.",
  phDataInputs_Zip_code_Validate_Required: "The postal code can not be empty.",
  phDataInputs_Zip_code_Validate_Pattern: "The postal code is invalid.",
  phDataInputs_City_Validate_Required: "The city can not be empty.",
  phDataInputs_City_Validate_Pattern: "The city is invalid.",
  phDataInputs_Addition_Validate_Required: "The addition can not be empty.",
  phDataInputs_Phone_Validate_MinLength: "Please enter at least 6 digits.",
  phDataInputs_Phone_Validate_Pattern: "Invalid phone number.",
  phDataInputs_Phone_Validate_Email: "The email is invalid.",
  phDataInputs_Country_Validate_Required: "The country can not be empty.",
  phDataInputs_Co_Validate_Required: "The C/O can not be empty.",
  phDataInputs_bday_ymd_DateNotValid: "Birthdate is not valid.",
  phDataInputs_bday_ymd_Validate_Required: "Birthdate can not be empty.",

  phLocationDialog_ConfirmButton: "Confirm",
  phLocationDialog_Title: "Choose Location",
  phLocationDialog_Description: "Please select your preferred locations so that you only see the information that is relevant to you. You can always adjust your selection in Locations.",

  phUserProfile_MyProfile: "My Profile",
  phUserProfile_Account: "My Account",
  phUserProfile_Order: "My Orders",
  phUserProfile_BillingInfo: "Billing Info",
  phUserProfile_Delivery_Address: "My Delivery Addresses",
  phUserProfile_User_Addresses: "My Addresses",
  phUserProfile_BonusPunkte: "My Bonus Points",
  phUserProfile_Webgutschein: "My Web Vouchers",
  phUserProfile_MyLike: "My Likes",
  phUserProfile_Feedback: "Feedback",
  phUserProfile_MyAccount_Description: "Edit your name, gender, and birthday.",
  phUserProfile_Order_Description: "Here you can view your orders",
  phUserProfile_MyAddress_Description: "Edit your billing- and delivery addresses here.",
  phUserProfile_PasswordChange_Description: "Would you like to change your password? No problem.",
  phUserProfile_WebGutschein_Description: "Here you can redeem your voucher code or generate a code.",
  phUserProfile_MyLike_Description: "Find your liked content quickly.",
  phUserProfile_Feedback_Description: "Would you like to give us feedback? Many Thanks!",
  phUserProfile_BonusPoint_Description: "Here you can see the current status of your bonus points.",
  phUserProfile_Tags_Subtext: "Here you can set your preferences.",

  phUserProfileDetail_Header: "My Settings",
  phUserProfileDetail_PlaceHolder_fName: "First Name",
  phUserProfileDetail_PlaceHolder_Name: "Last Name",
  phUserProfileDetail_PlaceHolder_Email: "E-Mail",
  phUserProfileDetail_PlaceHolder_Birthday: "Birthday",
  phUserProfileDetail_PlaceHolder_Gender: "Gender",
  phUserProfileDetail_PlaceHolder_PostalCode: "Post Code",
  phUserProfileDetail_Label_ChangePassword: "Change Password",
  phUserProfileDetail_Label_Logout: "Log Out",
  phUserProfileDetail_Option_Title: "Options",
  phUserProfileDetail_Tab_Header_AccounntInfo: "My Account",
  phUserProfileDetail_Tab_Header_Order: "My Orders",
  phUserProfileDetail_Tab_Header_Addresses: "My Addresses",
  phUserProfileDetail_Tab_Header_Preferences: "My Preferences",
  phUserProfileDetail_Billing_Address: "My Billing Address",
  phUserProfileDetail_Delivery_Address: "My Delivery Addresses",
  phUserProfileDetail_Botton_Label_NewAddress: "New Address",
  phUserProfileDetail_Save_User_Info: "Save",
  phUserProfileDetail_Tags_Subtext: "Here you can enter your preferences and sort our offer accordingly.",
  phUserProfileDetail_Tags_Title: "Preferences",
  phUserProfileDetail_Empty_Order: "Once you have ordered something in our store, you can view your order history here.",
  phUserProfileDetail_Order_List_Header: "Your order from:",
  phUserProfileDetail_Order_Location: "Location:",
  phUserProfileDetail_Order_Amount: "Total:",

  phUserOrderDetail_Date_Time: "Date/Time",
  phUserOrderDetail_Order_Service: "Order type:",
  phUserOrderDetail_Payment_Type: "Payment type:",
  phUserOrderDetail_Order_Nr: "Order number:",
  phUserOrderDetail_State: "State:",
  phUserOrderDetail_State_In_Progress: "In progress",
  phUserOrderDetail_State_Done: "Completed",
  phUserOrderDetail_Item_Header: "Item",
  phUserOrderDetail_Price_Header: "Price",
  phUserOrderDetail_NoCOO_Pin_Info_Label: "Pin to view your bill",
  phUserOrderDetail_NoCOO_Pin: "PIN:",
  phUserOrderDetail_Billing_Button_Label: "To the bill",
  phUserOrderDetail_GroupName: "Group name: {groupName}",

  phUserProfileDetail_Delete_Account: "Delete profile",
  phDeleteAccountDialog_Content: "Are you sure you want to delete your profile?<br>Deleting your profile will result in the loss of all saved data and you will be logged out automatically. This process can not be undone.",
  phDeleteAccountDialog_Confirm: "Your profile was successfully deleted",
  phDeleteAccountDialog_Confirm_Text: "Your profile has been successfully deleted. Please press the button below to return to the home page.",

  phUserProfileAddress_MainAddress_Title: "My Billing Address",
  phUserProfileAddress_DeliVeryAddress_Title: "My Delivery Address",
  phUserProfileAddress_NewDeliveryAddress_Title: "New Delivery Address",
  phUserProfileAddress_Save_User_Info: "Save",
  phUserProfileAddress_Delete_Address_Button: "Delete Address",
  phUserProfileAddress_Announce_Dialog_Title: "Delete Address",
  phUserProfileAddress_Announce_Dialog_Content: "Do you really want to delete this address?",
  phUserProfileAddress_Announce_Dialog_FirestBtn_Label: "Yes",
  phUserProfileAddress_Announce_Dialog_SecondBtn_Label: "No",

  phChangePassword_Title: "Change Password",
  phChangePassword_Message: "Enter your current and new password so we can change your password",
  phChangePassword_ChangePassword_button: "Change Password",
  phChangePassword_Label_OldPassword: "Old Password",
  phChangePassword_Label_NewPassword: "New Password",
  phChangePassword_Label_confirmPassword: "Confirm Password",
  phChangePassword_Validate_Password: "Your password must consists of 8 characters, at least one letter and one number.",
  phChangePassword_Confirm_Password: "Please enter the same password again",
  phChangePassword_Validate_Password_Required: "The old password cannot be empty.",

  phFeedback_Title: "Feedback",
  phFeedback_Modal_Title: "Rating",
  phFeedback_Button_Rate: "I was completely satisfied!",
  phFeedback_Button_Feedback: "Suggestions for improvement & criticism",
  phFeedback_Message: "The <customer> team is here to make sure that you had a good stay and that you enjoyed using the app. Simply click on the respective button depending on whether you were satisfied with the app or something did not go as you imagined and you have suggestions for improvement.",

  phWebvoucher_Detail_Value: "Value",
  phWebvoucher_Detail_Desired_Value: "Desired value",
  phWebvoucher_Detail_Number_Of_Persons: "Number of persons",
  phWebvoucher_Detail_Selected_Number_Of_Persons: "Persons",
  phWebvoucher_Detail_Selected_Single_Person: "Person",
  phWebvoucher_Detail_Email_Delivery: "Download",
  phWebvoucher_Detail_Post_Delivery: "Postal delivery",
  phWebvoucher_Detail_Free_Delivery: "free of charge",
  phWebvoucher_Detail_Plus_Cost_Delivery: "Plus shipping costs",
  phWebVoucher_Detail_Tab_Overview: "Overview",
  phWebVoucher_Detail_Tab_Preview: "Preview",
  phWebVoucher_Detail_Show_More: "Show more",
  phWebVoucher_Detail_Show_Less: "Show less",

  phWebvoucher_Title: "Add Code",
  phWebvoucher_button_continue: "Continue",
  phWebvoucher_button_ToShop: "To the shop",
  phWebvoucher_vouchercode_PlaceHolder: "Enter your Code here",
  phWebvoucher_EnterCode_Title: "Do you already have a Voucher Code?",
  phWebvoucher_EnterCode_Description: "Please enter the 18-digit number here.",
  phWebvoucher_CreateVoucher_Button: "Create Code",
  phWebVoucher_CreateVoucher_Title: "You don't have a Voucher Code yet?",
  phWebVoucher_CreateVoucher_Description: "To collect bonus points or to charge credit you need a Voucher Code once, click on \"Create Code\" to generate it now.",
  phWebvoucher_Error_Blocked: "the entered Code was entered too often wrong. try again in <delaytime> minutes.",
  phWebvoucher_Error_UsedWebvoucher: "The entered Code is invalid or already linked to another account",
  phWebvoucher_Error_WrongWebvoucher: "The entered Code is incorrect",
  phWebvoucher_Validate_Code: "The entered Code is invalid",
  phWebvoucher_MuchTry_Title: "You already have some Voucher Codes...",
  phWebvoucher_MuchTry_Description: "You have already generated a new Voucher Code several times. Please contact our service staff at one of our locations, we will be glad to help you.",
  phWebvoucher_MuchTry_Button: "Close",

  phWebvoucherDetail_Title: "Your QR Code",
  phWebvoucherDetail_button_Title: "Remove Code",
  phWebvoucherDetail_Date_Caption: "Data from",
  phWebvoucherDetail_Button_Refresh: "Refresh",

  phWebvoucherModal_Header: "Remove Code",
  phWebvoucherModal_Text: "If you have more than one code, you can remove the stored code here and register another code. All contents of your previous code will of course remain stored on it and can be added again at any time.",
  phWebvoucherModal_TextNote: "<b>IMPORTANT:</b> Please make a note of your current code to be able to use it again later, it is",
  phWebvoucherModal_RemoveButton_Label: "Remove Code",

  phBonusAction_Your_QR: "Your QR Code",
  phBonusAction_QR_Text: "Open your QR code here to collect bonus points or redeem rewards.",
  phBonusAction_Create_QR: "Your QR Code",
  phBonusAction_Create_QR_Text: "To collect bonus points or redeem rewards you need a QR code once. Create it here now.",
  phBonusAction_Cost_Points: "<points> points",
  phBonusAction_Circle_Points: "Points",
  phBonusAction_Redeem_Benefits: "Redeem now!",
  phBonusAction_Register_Benefits: "Register now!",
  phBonusAction_Benefits: "Benefits",
  phBonusAction_Costs_inBasket_Points: "{benefitCosts} of your {currentPoints} points are in the shopping cart  and will be redeemed.",
  phBonusAction_Current_Points: "Your Points:",
  phBonusAction_To_Benefits: "Show details",
  phBonusAction_Load_Points_Error: "The points could not be displayed at this time",

  phBonusActionDetails_Location: "Participating locations",

  phBenefit_Redeem_Dialog_Title: "How would you like to redeem the bonus points?",
  phBenefit_Redeem_Dialog_InStore_Desc: "Show the QR code at the checkout and redeem the points in store.",
  phBenefit_Redeem_Dialog_InStore_Btn: "In store",
  phBenefit_Redeem_Dialog_Online_Desc: "Redeem points directly online and add the reward to your shopping cart",
  phBenefit_Redeem_Dialog_Online_Btn: "Redeem now",
  phBenefit_Redeem_LocationAndOrderType_Dialog_Title: "Where would you like to redeem the bonus points?",
  phBenefit_Redeem_LocationAndOrderType_Dialog_Tab_Location_Desc: "Please select a location to redeem your bonus points.",
  phBenefit_Redeem_LocationAndOrderType_Dialog_Tab_OrderType_Desc: "How would you like to redeem the bonus points with us?",
  phBenefit_Redeem_LocationAndOrderType_Dialog_Tab_OrderType_Empty: "Unfortunately, the selected reward cannot be redeemed at this location. Please try another reward.",
  phBenefit_Redeem_Table_Login_Required_Dialog_Title: "Table code required",
  phBenefit_Redeem_Table_Login_Required_Dialog_Desc: "Please scan a table code first before you can redeem the bonus points.",
  phBenefit_Redeem_OrderType_Not_Valid_Dialog_Title: "Order type invalid",
  phBenefit_Redeem_OrderType_Not_Valid_Dialog_SubText: "Unfortunately, bonus points cannot be redeemed for your selected order type, please select another order type.",
  phBenefit_Redeem_OrderType_Not_Valid_Dialog_Change_Btn: "Change order type",
  phBenefit_Redeem_OrderType_Not_Valid_Dialog_Cancel_Btn: "Cancel",
  phBenefit_Redeem_No_Product_Dialog_Title: "Reward not redeemable",
  phBenefit_Redeem_No_Product_Dialog_Info: "Unfortunately, the reward cannot be redeemed. Please select another reward.",
  phBenefit_Redeem_Product_NotAvailable_Dialog_Title: "Reward not available",
  phBenefit_Redeem_Product_NotAvailable_Dialog_Info: "Unfortunately, the reward is currently not available. Please try again tomorrow.",
  phBenefit_Redeem_Cost_Points_Info: "{points} Points",
  phBenefit_Redeem_Not_Enough_Points_Dialog_Title: "Not enough points available.",
  phBenefit_Redeem_Not_Enough_PointsDialog_SubText: "You already have benefits worth {consumedPoints} in your cart from this action. Your available points for this action are {availablePoints}. \nPlease remove another benefit from your cart to redeem this one.",

  phCoupon_Show_Code: "Show coupon code",
  phCoupon_Redeem_Now: "Redeem now in the store",
  phCoupon_Members: "Members only",
  phCouponDetail_Content: "You must be registered with <customer> to use this coupon. Not a member yet? Then register now!",
  phCoupon_Expires_On: "Expires on",
  phCoupon_Expires_On_End: "",
  phCoupon_Expires_Today: "Expires today",

  phSelectedLayer_Title: "Choose Location",
  phSelectedLayer_Description: "Please select your desired location, this can always be changed in the title bar.",

  phMenuGroup_Header: "Menu",
  phMenuGroup_DialogHeader: "All categories",

  phMenu_DislikeSeperator_title: "Dislike",

  phMenuDetail_ExtragroupTitle: "Choice",
  phMenuDetail_Required: "Required",

  phLoginDialog_Title: "Just for <customer> Members!",
  phLoginDialog_Content: "You must be registered with <customer> to use this function. Not a member yet? Then register now!",
  phLoginDialog_Content_ModuleName: "You must be registered at <customer> to be able to use the area <modulename>. Not a member yet ? Then register now!",

  phUserLike_Header: "My Likes",

  phProductDetail_Description: "Description",
  phProductDetail_Overview: "Overview",
  phProductDetail_CO2: "CO2",
  phProductDetail_Additives: "Additives",
  phProductDetail_Nutrition: "Nutritional information",
  phProductDetail_Allergy: "Allergens",
  phProductDetail_Content: "List of ingredients",
  phProductDetail_Distributor: "Responsible company",
  phProductDetail_Labelling: "Product Informations",
  phProductDetail_Date_Caption: "Menu from ",
  phProductDetail_AdditionalInformations: "Additional information",
  phProductDetail_ShowAdditionalOption: "Show additional options",
  phProductDetail_ShowLessOption: "Show fewer options",
  phProductDetail_InfosNotForCustomizedOrders_TEXT: "Details do not refer to personalised orders",
  phProductDetail_Announce_Dialog_Title: "Order not possible",
  phProductDetail_Announce_Dialog_Content: "You are in our 'browse' area, in which no order can be placed. Please select another order type.",
  phProductDetail_Announce_Dialog_FirstBtn_Label: "Select Order Type",
  phProductDetail_Announce_Dialog_SecondBtn_Label: "Continue browsing",
  phProductDetail_CurrentlyNotAvailable: "currently not available",
  phProductDetail_includeDeposit: "incl.{deposit} deposit",
  phProductDetail_plusDeposit: "plus {deposit} deposit",
  phProductDetail_Alcohol_Content: "Alcohol content {value}",
  phProductDetail_Caffeine_Content: "Caffeine content {value}",
  phProductDetail_EnterYourDesiredAmount: "Enter your desired amount",
  phProductDetail_prepackaged: "Prepackaged",

  phExternalLinkModal_confirmation_Title: "You are leaving our app",
  phExternalLinkModal_confirmation_Title_eMenu: "You are leaving our app",
  phExternalLinkModal_confirm_Button_Text: "Continue",

  phConfirmDialog_NoCOO_Title: "Forwarding to the invoice portal",
  phConfirmDialog_NoCOO_Text: "Please click the button below to be redirected to our Invoice portal.",
  phConfirmDialog_NoCOO_Button: "Continue",

  phMenuService_Choice: "Order Type",
  phMenuService_PlsChooseService_TEXT: "Please select how you would like to order from us.",
  phMenuService_ViewMenu: "View Menu",
  phMenuService_ViewMenu_SubText: "Do you just want to browse and not place an order?",
  phMenuService_OderToTable: "Order to the Table",
  phMenuService_OrderToTable_SubText: "Order directly at the table in the restaurant with QR code.",
  phMenuService_TakeAway: "For Takeaway",
  phMenuService_TakeAway_SubText: "Order now and pick up on the spot.",
  phMenuService_TakeAway_Group: "Group order Pickup",
  phMenuService_Delivery: "Delivery",
  phMenuService_Delivery_SubText: "Just enter your position, select your location and go.",
  phMenuService_Delivery_Group: "Group order delivery",

  phMenuService_Webvoucher_WithCharging: "Voucher & credit",
  phMenuService_Webvoucher_SubText_WithCharging: "Here you can charge your credit or order vouchers.",
  phMenuService_Webvoucher: "Voucher",
  phMenuService_Webvoucher_SubText: "Order vouchers here and receive them straight away by E-Mail.",

  phWebshop_ShippingCart_Nav_Header: "Shopping cart",
  phWebshop_OrderData_Nav_Headero: "Customer data",
  phWebshop_Payment_Nav_Header: "Payment",
  phWebshop_FreeShippingAt_BASE: "Add items worth {amount} to avoid paying delivery fees.",
  phWebshop_PleaseChooseDeliveryCountry: "Please select the delivery country:",
  phWebshop_SelectPickupTime: "Please select your desired pickup time.",
  phWebshop_SelectPickupTime_subText: "By when would you like to pick up your order?",
  phWebshop_SelectDeliveryTime: "Please select your desired delivery time.",
  phWebshop_SelectDeliveryTime_subText: "By when would you like to receive your order?",
  phWebshop_SelectOrderSubmissionTime: "Please select your desired order time.",
  phWebshop_SelectOrderSubmissionTime_subText: "By when would you like to order?",
  phWebshop_Pickup_Day_Label: "Takeaway day",
  phWebshop_Delivery_Day_Label: "Delivery day",
  phWebshop_AsSoonAsPossible: "as soon as possible",
  phWebshop_Pickup_Time_Label: "Takeaway time",
  phWebshop_Delivery_Time_Label: "Delivery Time",
  phWebshop_InHause_Time: "Order time: now",
  phWebshop_NoDelivery_Time: "No delivery is possible today",
  phWebshop_NoPickup_Time: "Unfortunately no pick-up is possible today",
  phWebshop_NoInHause_Time: "Today it is not possible to order to the table",
  phWebshop_Item_Show_Comment: "Note",
  phWebshop_Item_Hide_Comment: "Note",
  phWebshop_Item_Benefit: "Benefit",
  phWebshop_ShippingCart_Total: "Total",
  phWebshop_ShippingCart_MinimumDelivery: "Minimum order value",
  phWebshop_Shippingcart_next: "Order now",
  phWebshop_Shippingcart_tip: "Tip",
  phWebshop_Shippingcart_DeliveryFee: "Delivery Charge",
  phWebshop_Shippingcart_SumOfProducts: "Sum",
  phWebshop_Shippingcart_IncludeDeposit_BASE: "incl. {deposit} deposit",
  phWebshop_Recommendation_Title: "Based on your order we recommend:",
  phWebshop_View_Cart: "View Cart",
  phWebshop_Shippingcart_Only_Benefit: "It is not possible to order only Benefit products. Please add more items.",

  phWebshop_includeDeposit: "incl. deposit",
  phWebshop_plusDeposit: "plus deposit",

  phOrderData_Username_Announce: "You are logged in as",
  phOrderData_Guest_register_comment: "Register to earn points, receive discounts and complete your next order faster & easier.",
  phOrderData_Order_As_Guest: "Or order as a guest",
  phOrderData_Order_Following_Information: "For further processing we need the following information from you.",
  phOrderData_selectBillAddress: "Your billing address",
  phOrderData_selectAddress: "Select a delivery address",
  phOrderData_selectNewAddress: "Select a new delivery address",
  phOrderData_Billing_Address_Is_Delivery_Address_Title: "Delivery address",
  phOrderData_Billing_Address_Is_Delivery_Address_Label: "Deliver to billing address",
  phOrderData_addNewAddress: "Create a new address",
  phOrderData_Different_Delivery_Address: "Different delivery address",
  phOrderData_Enter_Different_Delivery_Address: "Enter a different delivery address",
  phOrderData_CurrentlyUsedDeliveryAddress: "Your delivery address: {address}, {zip} {city}",
  phOrderData_CurrentlyUsedBillingAddress: "Your billing address: {address}, {zip} {city}",

  phPayment_Webvoucher_Usage: "Use Voucher",
  phPayment_RedeemWebvoucher: "Redeem Voucher Code (18 digits)",
  phPayment_Webvoucher_Info_BASE: "Your Voucher ({Nr}) has a value of {Amount}",
  phPayment_Webvoucher_Info_Discount_BASE: "Your Voucher ({Nr}) has a value of {Amount} and a discount of {Discount}",
  phPayment_Webvoucher_OnlyNr_BASE: "Your Voucher has the number {SimpleNr}",
  phPayment_Webvoucher_OnlyNrAndDiscount_BASE: "Your Voucher ({Nr}) has a discount of {Discount}",
  phPayment_Validate_WebvoucherPattern: "Voucher Code must be an 18-digit number",
  phPayment_Validate_WebvoucherExists: "No valid Voucher could be found",
  phPayment_PayPal: "PayPal",
  phPayment_Accounting: "On Account",
  phPayment_CashlessTakeaway: "Cashless on takeaway",
  phPayment_CashlessDelivery: "Cashless on delivery",
  phPayment_CashDelivery: "Cash on delivery",
  phPayment_PayOnCollection: "Payment on takeaway",
  phPayment_Webvoucher: "Web Voucher",
  phPayment_PayAtWaiter: "Pay at the cash register",
  phPayment_FinalPrice: "Amount to be paid",
  phPayment_ChooseYourPaymentMethod: "Choose your payment method",
  phPayment_MorePaymentMethods: "Other payment options",
  phPayment_AcceptTerms_BASE: "With the payable order I accept the {customer}-{terms}",
  phPayment_OrderNowWithCosts: "Order now subject to charge",
  phPayment_PayNow: "Pay now",
  phPayment_CommentToYourOrder: "Do you wish to add comments on the order?",
  phPayment_UnsupportedCardType_Title: "Unsupported card brand",
  phPayment_UnsupportedCardType_Content: "The brand of the card is not supported as a payment method. Please check your entered card number or use another payment method.",
  phPayment_UnsupportedCardType_Button: "Back",
  phPayment_NoDeliveryAddress: "No delivery address could be determined. Please provide either a delivery or a billing address.",

  phPayment_MethodName_amex: "American Express",
  phPayment_MethodName_applepay: "Apple Pay",
  phPayment_MethodName_diners: "Diners",
  phPayment_MethodName_directEbanking: "Sofort",
  phPayment_MethodName_discover: "Discover",
  phPayment_MethodName_jcb: "JCB",
  phPayment_MethodName_mc: "Mastercard",
  phPayment_MethodName_paypal: "PayPal",
  phPayment_MethodName_paywithgoogle: "Google Pay",
  phPayment_MethodName_visa: "Visa",
  phPayment_MethodName_unknownn: "Unknown",
  phPayment_MethodName_Cash_DeliveryTakeAway: "Cash",
  phPayment_MethodName_ec: "EC",
  phPayment_MethodName_EcNational: "Ec-National",
  phPayment_MethodName_EcInternational: "Card-International",
  phPayment_MethodName_EcForeign: "Ec-Foreign",
  phPayment_MethodName_ECustomerCard: "Ec-Customercard",
  phPayment_MethodName_Breuninger: "Breuninger",
  phPayment_MethodName_ecCash: "Ec-Cash",
  phPayment_MethodName_sonstigeKreditkarten: "Other Credit Card",
  phPayment_MethodName_AdrevaMacao: "AdrevaMacao",
  phPayment_MethodName_IKEAFamilyCard: "IKEAFamilyCard",
  phPayment_MethodName_VisaDebit: "Visa Debit",
  phPayment_MethodName_MCDebit: "MC Debit",
  phPayment_MethodName_Maestro: "Maestro",
  phPayment_MethodName_VPay: "VPay",
  phPayment_MethodName_Postcard: "Postcard",
  phPayment_MethodName_PayPalPicturePayment: "PayPalPicturePayment",
  phPayment_MethodName_Deposit: "Deposit",
  phPayment_MethodName_Payout: "Payout",
  phPayment_MethodName_twint: "TWINT",
  phPayment_MethodName_WebInvoice: "WebInvoice",
  phPayment_MethodName_ZahlungAnstehend: "CashPayment Pending",
  phPayment_MethodName_CashController: "CashController",
  phPayment_MethodName_PayPerApp: "PayPerApp",
  phPayment_MethodName_Cashess_Delivery: "Cashless",
  phPayment_MethodName_PayDirect: "Paydirekt",
  phPayment_MethodName_LunchCard: "Lunch Card",
  phPayment_MethodName_LunchCheckCard: "Lunch Check Card",
  phPayment_MethodName_MaestroCH: "Maestro CH",
  phPayment_MethodName_PowerCard: "Power Card",
  phPayment_MethodName_Loeb: "Loeb",
  phPayment_MethodName_Manorcard: "Manorcard",
  phPayment_MethodName_WIRcard: "WIRcard",
  phPayment_MethodName_Reka: "Reka",
  phPayment_MethodName_Giftcard: "Giftcard",
  phPayment_MethodName_ChinaUnionPay: "China UnionPay",
  phPayment_MethodName_Alipay: "Alipay",
  phPayment_MethodName_WeChat: "WeChat",
  phPayment_MethodName_Sodexo: "Sodexo",
  phPayment_MethodName_TWINTTerminal: "Twint Terminal",
  phPayment_MethodName_OnlineZahlung: "Online payment",
  phPayment_MethodName_AmazonPay: "AmazonPay",
  phPayment_MethodName_klarna_paynow: "Klarna Pay Now",
  phPayment_MethodName_EPS_AT: "EPS AT",
  phPayment_MethodName_Paysafecard: "PaySafecard",
  phPayment_MethodName_Wallet: "Wallet",
  phPayment_MethodName_Sepa: "SEPA",
  phPayment_MethodName_Girocard: "Girocard",
  phPayment_MethodName_Voucher: "Webvoucher",
  phPayment_MethodName_MPA: "On Account",
  phPayment_MethodName_Cashless_DeliveryTakeaway: "Cashless",
  phPayment_MethodName_PayAtPOS: "Pay at POS",
  phPayment_MethodName_scheme: "Cards",

  phHome_Today: "Today",

  phArticleCard_ArticleUnavailable: "This item is currently not available",
  phArticleCard_Recipe_Price_from: "from",

  phAvailableService_title_Delivery: "Nice that you want to order from us.",
  phAvailableService_title_Tekeaway: "Nice that you want to order from us for pickup.",
  phAvailableService_title_InHouse: "Nice that you want to order \"at the table\" with us.",
  phAvailableService_title_OpenTime: "It's nice that you want to order from us!",
  phAvailableService_content_Delivery: "Unfortunately, we are currently closed, but we will gladly accept your order and deliver to you within our opening hours. Simply select your desired delivery time in the next step.",
  phAvailableService_content_Tekeaway: "Unfortunately, we are currently closed, but we will gladly accept your order so that you can pick it up during our opening hours. Simply select your desired pick-up time in the next step.",
  phAvailableService_content_NoValidTime_Delivery: "Unfortunately, no delivery times are available.",
  phAvailableService_content_NoValidTime_Takeaway: "Unfortunately, no pickup times are available.",
  phAvailableService_content_InHouse: "Unfortunately, you want to order outside our ordering hours. These are:",
  phAvailableService_content_OpenTime: "It looks like we are closed right now. Please note our opening hours when placing your order.",

  phMenuChangeLocationDialog_YouAreInLocation_BASE: "You are in {location}.",
  phMenuChangeLocationDialog_YouAreKmAway_BASE: "You are > {distance} km from the restaurant.",
  phMenuChangeLocationDialog_Address: "Address",
  phMenuChangeLocationDialog_Opentimes: "Opening Times",
  phMenuChangeLocationDialog_ChangeLocation: "Choose Location",
  phMenuChangeLocationDialog_ChangeService: "Change Order Type",

  phOrderDataInputs_prefix: "Prefix",
  phOrderDataInputs_fname: "First Name",
  phOrderDataInputs_name: "Last Name",
  phOrderDataInputs_companyAddress: "Company Address",
  phOrderDataInputs_co: "C/O",
  phOrderDataInputs_address: "Street & House Number",
  phOrderDataInputs_street: "Street",
  phOrderDataInputs_house_number: "House number",
  phOrderDataInputs_addition: "Additions",
  phOrderDataInputs_zip_code: "Post Code",
  phOrderDataInputs_city: "City",
  phOrderDataInputs_country: "Country",
  phOrderDataInputs_email: "E-Mail",
  phOrderDataInputs_telephone1: "Private Phone",
  phOrderDataInputs_telephone2: "Work Phone",
  phOrderDataInputs_telephone_mobile: "Mobile Phone",
  phOrderDataInputs_fax: "Fax",
  phOrderDataInputs_privatAccess: "Accessibility from - Accessibility to (private)",
  phOrderDataInputs_workAccess: "Availability from - Availability to (business)",
  phOrderDataInputs_bday_ymd: "Date of birth",

  phOrderDataInputs_Name_Validate_Error: "The name can not be empty.",
  phOrderDataInputs_Family_Validate_Error: "The last name can not be empty.",
  phOrderDataInputs_Gender_Validate_Error: "The gender can not be empty.",
  phOrderDataInputs_address_Validate_Error: "The address can not be empty.",
  phOrderDataInputs_zip_code_Validate_Error: "The postal code can not be empty.",
  phOrderDataInputs_city_Validate_Error: "The city can not be empty.",
  phOrderDataInputs_addition_Validate_Error: "The addition can not be empty.",
  phOrderDataInputs_country_Validate_Error: "The country can not be empty.",
  phOrderDataInputs_co_Validate_Error: "The C/O can not be empty.",
  phOrderDataInputs_bday_ymd_DateNotValid_Error: "Birthdate is not valid.",
  phOrderDataInputs_bday_ymd_Validate_Error: "Birthdate can not be empty.",

  ph_menuLocation_Select_PostalCode: "Please enter your postal code here",
  ph_menuLocation_Search: "Enter postal code or city",
  ph_menuLocation_cityList: "Select location",
  ph_menuLocation_ZipCode_Warning_Title: "Where would you like to be delivered to?",
  ph_menuLocation_ZipCode_Warning_Content: "Please enter your zip code so we can check if you are in our delivery area.",
  ph_menuLocation_ZipCode_Warning_BtnLabel: "Enter postal code",
  ph_menuLocation_ZipCode_Warning_Option: "If we are unable to deliver to you, you are welcome to collect your order from us, of course. Please select the order type 'pick-up'.",
  ph_menuLocation_Other_Postalcode: "Change postal code",
  ph_menuLocation_Your_Current_Location: "Current postcode: ",
  ph_menuLocation_Your_Current_Address: "Current address:{address}",
  ph_menuLocation_Announce_Dialog_Title: "Delivery not possible",
  ph_menuLocation_Announce_Dialog_Content: "Unfortunately we cannot supply your current position. Please enter a different postal code or change the order type.",
  ph_menuLocation_Announce_Dialog_FirstBtn_Label: "Other postal code",
  ph_menuLocation_Announce_Dialog_PolyMap_Content: "Unfortunately we cannot supply your current position. Please enter a different address or change the order type.",
  ph_menuLocation_Announce_Dialog_PolyMap_FirstBtn_Label: "Other address",
  ph_menuLocation_Announce_Dialog_SecondBtn_Label: "Select Order Type",
  ph_MenuLocation_WebVoucher_Title: "What is your favourite location?",
  ph_MenuLocation_WebVoucher_SubTitle: "Of course you can redeem our vouchers at all locations.",
  ph_menuLocation_Address_Required_Warning_Info: "Unfortunately, the exact address could not be found. The locations are displayed by postcode.",

  phOrderAddressQuery_VerifyAdjusted_Title: "The entered address could not be uniquely confirmed. We have determined the following address:",
  phOrderAddressQuery_UseSuggestion_BtnLabel: "Use suggested address",
  phOrderAddressQuery_Cancel_BtnLabel: "Edit address",
  phOrderAddressQuery_KeepMyInput_BtnLabel: "Use my input",
  phAddressCompare_YourInput_Label: "Your input:",
  phAddressCompare_SuggestedAddress_Label: "Suggested address:",
  phUserProfileAddress_VerifyUnavailable_Title: "Address verification currently not possible",
  phUserProfileAddress_VerifyUnavailable_Content: "The address could not be verified at the moment. Please try again later.",
  phUserProfileAddress_VerifyUnavailable_BtnLabel: "OK",
  phUserProfileAddress_VerifyInvalid_Title: "Address incomplete or invalid",
  phUserProfileAddress_VerifyInvalid_Content: "The entered address could not be uniquely confirmed. Please check the details and adjust them.",

  phOrderResult_ThankYouForYourOrder: "Thanks for your order",
  phOrderResult_ConfirmationMailSend_TEXT: "We have just sent you an order confirmation by E-Mail to {email}.",
  phOrderResult_Success_YourOrder: "Your order:",
  phOrderResult_SuccessDelivery_BASE_Nostreet: "Your order ({orderid}) will be delivered {time}.",
  phOrderResult_SuccessDelivery_BASE: "Your order ({orderid}) will be delivered{day} {time} in the {street}.",
  phOrderResult_SuccessInHause_BASE: "Your order ({orderid}) has been received and will be delivered to your table in no time!",
  phOrderResult_SuccessPickup_BASE_Nostreet: "Your order ({orderid}) will be ready for pickup {time}.",
  phOrderResult_SuccessPickup_BASE: "Your order ({orderid}) will be ready to be picked up at {street}{day} {time}.",
  phOrderResult_SuccessDelivery_BASE_Hero_Nostreet: "({orderid}) will be delivered {time}.",
  phOrderResult_SuccessDelivery_BASE_Hero: "({orderid}) will be delivered{day} {time} in the {street}.",
  phOrderResult_SuccessPickup_BASE_Hero_Nostreet: "({orderid}) will be ready for pickup {time}.",
  phOrderResult_SuccessPickup_BASE_Hero: "({orderid}) will be ready to be picked up at {street}{day} {time}.",
  phOrderResult_Success_Retail_WillBePackaged_TEXT: "will be packed immediately and shipped to you in the next few days.",
  phOrderResult_DayAtPrefix: "on",
  phOrderResult_TimeAboutPrefix: "at about",
  phOrderResult_AsSoonAsPossible: "ASAP",
  phOrderResult_PhoneNumberForCallback: "Telephone number for enquiries",
  phOrderResult_ToTheHomescreen: "Back to the start screen",
  phOrderResult_YourOrderWasCancelled: "Your order was cancelled, please try again",
  phOrderResult_DoYouWantToContinue_TEXT: "Do you want to continue your order or choose another payment method? Then choose back to the check-out.",
  phOrderResult_ReturnToCheckout: "Back to Check-Out",
  phOrderResult_OrderCouldNotBeAccepted: "Your order could not be accepted",
  phOrderResult_ThereWasAProblem_TEXT: "There seems to be a problem with your order, please try another payment method.",
  phOrderResult_CollectedPointsForBonus_BASE: "You have collected {points} for the bonus action {bonusaction}!",
  phOrderResult_Points: "Points",
  phOrderResult_Point: "Point",
  phOrderResult_SuccessWebvoucher_DownloadText: "You can download your vouchers via the following links.",
  phOrderResult_SuccessWebvoucher_ConfirmationMailSend: "In addition we have also sent them to you by E-Mail to {email}.",
  phOrderResult_SuccessWebvoucher_ConfirmationPostSend: "We will send your vouchers shortly to the delivery address you provided.",
  phOrderResult_WebVoucherOrderList_header: "Voucher(s)",
  phOrderResult_SuccessWebvoucher_TitleVoucher: "Voucher",
  phOrderResult_SuccessWebvoucher_Person_Count: "Persons",
  phOrderResult_SuccessWebvoucher_Person_Post_Delivery: "Post delivery",
  phOrderResult_SuccessWebvoucher_Person_Mail_Delivery: "Download",
  phOrderResult_SuccessWebvoucher_TitleAmount: "Amount",
  phOrderResult_SuccessWebvoucher_TitleLink: "Link to the Voucher",
  phOrderResult_SuccessWebvoucher_TextLink: "PDF",
  phOrderResult_SuccessWebvoucher_ButtonLink: "Download Voucher(s)",
  phOrderResult_SuccessTicket_DownloadText: "You can download your tickets via the following links.",
  phOrderResult_SuccessTicket_TitleTicket: "Tickets",
  phOrderResult_SuccessTicket_ButtonLink: "Download Ticket(s)",
  phOrderResult_CloseTab: "Close tab",
  phOrderResult_VoucherCredit_Charge: "We have increased your balance by the amount you requested.",

  phInvalidDeliveryAddress_Title: "This has not worked",
  phInvalidDeliveryAddress_content: "Unfortunately, this address cannot be supplied from the selected location. Please select a different delivery address, or another location. If you select another location, the shopping cart will be emptied when you change.",

  phResetBasketWarning_Title: "Items in shopping cart",
  phResetBasketWarning_SubHeaderContent: "You have added items for location {locationName}.",
  phResetBasketWarning_Content: "Do you want to start with a new selection or continue the current order.",
  phResetBasketWarning_RemainOrder_Button: "Continue",
  phResetBasketWarning_ResetBasket_Button: "New Order",

  phDiscardBasketDialog_Title: "Really discard the order?",
  phDiscardBasketDialog_Content: "Do you really want to discard your order and order from us another way?",
  phDiscardBasketDialog_RemainOrder_Button: "Back",
  phDiscardBasketDialog_ResetBasket_Button: "Discard order",

  phWebshopVacationWarning_Button: "Okay",

  phQRCode_Page_Title: "In House Order",
  phQRCode_page_Description: "Please scan the table code to order now.",
  phQRCode_Access_Denied_Text: "Unfortunately we cannot access your camera.<br><br>Please check your mobile phone or browser settings if necessary.",
  phQRCode_PlaceHolder: "5-digit Table Code",
  phQRCode_Page_Button: "Enter Table Code",
  phQRCode_ScanFail_Title: "The QR Code is not readable",
  phQRCode_ScanFail_Content: "Unfortunately, the QR Code could not be read. Enter the QR Code in the text area.",
  phQRCode_ScanFail_Button_Text: "Close",
  phQRCodeScanner_NoCamera_HTML: "No camera? No problem!<br>Simply enter the 5-digit Table Code and order immediately.",

  phQRCode_Manual_Page_Title: "In House Order",
  phQRCode_Manual_Page_Description: "Please enter your 5-digit table code here.",
  phQRCode_Manual_Page_Button: "Next",
  phQRCode_Manual_Validate: "Table code is invalid",

  phQrcode_Brightness_Adgustment_Browser: "For optimal scan results, please adjust the brightness.",

  phInHouseOrdering_Title: "Order to the table",
  phInHouseOrdering_description: "Order now conveniently with your smartphone and receive your order in a short time directly to the table.",
  phInHouseOrdering_Button_Text: "Next",

  phInHouse_NoQRCode_Warning_Title: "The table code is unfortunately not valid",
  phInHouse_NoQRCode_Warning_Description: "Unfortunately, the table code you entered is not valid. Please check your entry or contact our service staff. We will be happy to help you.",
  phInHouse_NoQRCode_Warning_Button_Text: "Close",

  phInHouse_NoLocation_Warning_Title: "Order type not available",
  phInHouse_NoLocation_Warning_Description: "Unfortunately, the type of order you called is not available, please contact our service staff.",
  phInHouse_NoLocation_Warning_Button_Text: "To the start screen",

  phVoucherCredit_Page_Title: "Voucher & Credit",
  phVoucherCredit_Page_Description: "Would you like to charge your customer card or order a new gift voucher?",
  phVoucherCredit_Credit_Title: "Charge credit",
  phVoucherCredit_Credit_Description: "Charge your customer card and make cashless payments in future.",
  phVoucherCredit_Voucher_Title: "Order a voucher",
  phVoucherCredit_Voucher_Description: "Order vouchers here and receive them immediately by E-Mail.",
  phVoucherCredit_Warning_Title: "Sorry...",
  phVoucherCredit_Warning_Description: "Unfortunately, we could not process your request. Please try again later.",

  phNewOrderTimeDialog_Title: "How the time flies...",
  phNewOrderTimeDialog_Description: "Unfortunately, we can no longer fulfil your order at the requested time.<br>Please select a new time.",
  phNewOrderTimeDialog_Description_Closed: "Unfortunately, we can no longer accept your order today.<br>Please come back here tomorrow.",
  phNewOrderTimeDialog_Button_NewTime: "Continue",
  phNewOrderTimeDialog_Button_Close: "Abort",

  phCookie_Cookie: "Cookies",
  phCookieBanner_Title: "We use cookies",
  phCookieBanner_Button_Accept: "Accept",
  phCookieBanner_Button_Deny: "Decline",
  phCookieBanner_Button_Accept_All: "Confirm all cookies",
  phCookieBanner_Button_Infos: "Data protection information",

  phCookieBanner_Content: "We would like to make our service as user-friendly as possible for you. To enable us to offer our functions optimally, necessary cookies are used. The processing of your personal data can be found in our data protection information. You confirm receipt and understanding of the data protection information on the use of necessary cookies by clicking the button below.",

  phCookieStatement_Title_First: "Necessary processing of personal data",
  phCookieStatement_Title_Second: "Necessary cookies",

  phCookieStatement_Button_Close: "Close",
  phCookieStatement_Table_cookieName: "Cookiename",
  phCookieStatement_Table_URL: "URL",
  phCookieStatement_Table_service: "Service",
  phCookieStatement_Table_validity: "Retention period",
  phCookieStatement_Table_country: "Place of processing",
  phCookieStatement_Table_active: "Active",
  phCookieStatement_Table_description: "Purpose of data processing",
  phCookieStatement_Table_company: "Processing Company",
  phCookieStatement_Table_rightTerms: "Legal basis",
  phCookieStatement_Table_technology: "Technologies used",
  phCookieStatement_Table_dataCollect: "Collected data",
  phCookieStatement_Table_dataRecipient: "Data recipient",
  phCookieStatement_Table_dataProtectionOfficer: "Data protection officer of the processing company",
  phCookieStatement_Table_dataProcessors: "Click here to read the data processor's privacy policy",

  phLicense_Licenses: "Licenses",
  phLicense_License: "License",
  phLicense_Title: "Used Licenses",
  phLicense_Name: "Name",
  phLicense_Version: "Version",
  phLicense_Author: "Author",
  phLicense_Showmore_Button: "Show more",
  phLicense_Showless_Button: "Show less",
  phLicense_URL: "URL",
  phLicense_Repository_URL: "Repository URL",
  phLicense_Description: "Description",
  phLicense_Close_Button: "Close",

  phOperator_Info_Title: "Information about the Operator",
  phOperator_Info_Content: "Hypersoft Trading GmbH is not responsible for the content of the ordering page. For questions regarding your order, products/menus, ingredients or nutritional values, please contact the restaurant mentioned above directly.",

  phFilterTagDialog_Title: "Preferences",
  phFilterTagDialog_Description: "Here you can enter your preferences and sort our offer accordingly.",
  phFilterTagDialog_Button_Save: "Accept",
  phFilterTagDialog_Button_Close: "Reset",
  phFilterTagDialog_Checkbox_Content: "Remember setting for future orders",

  phA11YDialog_Headline: "Accessible",
  phA11YDialog_Title: "Accessibility Mode",
  phA11YDialog_Description: "Accessibility Mode. Select the desired mode to activate it.",
  phA11YDialog_Button_FontSize: "Increase font size",
  phA11YDialog_Button_ColorContrast: "Increase color contrast",
  phA11YDialog_Button_HideImages: "Hide Images",
  phA11YDialog_Button_ReducedMotion: "Reduced Motion",
  phA11YDialog_Button_Back: "Back",
  phA11YDialog_Button_Confirm: "Confirm",
  phA11YDialog_Button_Close: "Reset",
  phA11YDialog_Button_MoreInfo: "More information on accessibility",
  phA11Y_image_alt_text: "Image: Visualizes the information described in the text.",

  phA11Y_slider: "Slider: Use the arrow keys to change the value.",
  phA11Y_no_aria: "Attention: This element does not contain ARIA attributes and may not be accessible.",
  phA11Y_button: "Button: Triggers an action.",
  phA11Y_spin_button: "Input field for numbers",
  phA11Y_input: "Input field: Enter text here.",
  phA11Y_select: "Selection box: Open the list and select an option.",
  phA11Y_checkbox: "Checkbox: Activate or deactivate this option.",
  phA11Y_link: "Link: Navigates to another page or section.",

  phA11Y_open_coupon_detail: "Open coupon details",

  phA11Y_calendar_day: "{day} {month} {year}",
  phA11Y_calendar_day_today: "{day} {month} {year}, Today",
  phA11Y_calendar_day_selected: "{day} {month} {year}, Selected",
  phA11Y_calendar_day_available: "Available",
  phA11Y_calendar_day_unavailable: "Not available",
  phA11Y_calendar_previous_month: "Previous month",
  phA11Y_calendar_next_month: "Next month",
  phA11Y_calendar_previous_year: "Previous year",
  phA11Y_calendar_next_year: "Next year",
  phA11Y_calendar_select_month: "{month} {year}, Select month",
  phA11Y_calendar_select_year: "{year}, Select year",
  phA11Y_calendar_year: "Select year {year}",

  phFixedBasketErrorPage_PleaseTryAgainLater_Text: "Our offer is being updated, please try again in a few minutes. Thank you for your understanding.",
  phFixedBasketErrorPage_NoBasket_Text: "The order has already been processed or the shopping cart is out of date. Please perform the order again. Thank you for your understanding.",

  phOpenLinkInApp_Text: "Open link in App?",
  phOpenLinkInApp_Action_Open: "Open",

  phInHouseOrder_CloseOrdering_Button: "Leave table",

  phServiceCall_Title: "Servicecall",
  phServiceCall_Description: "How can we help you?",
  phServiceCall_SecureCheckDialog_Title: "Do you want to submit the service call now?",
  phServiceCall_SecureCheckDialog_AcceptBtn_Label: "Accept",
  phServiceCall_SecureCheckDialog_DenyBtn_Label: "Deny",
  phServiceCall_Success_Title: "The service call was successfully transmitted, we will take care of your request as soon as possible.",
  phServiceCall_Fail_Title: "Service call failed!",
  phServiceCall_Button: "Ok",

  phInHouseService_Ordered_Items: "Ordered items",
  phInHouseService_Open_Bill: "Open bill",
  phInHouseService_NoOrderYet_Title: "No items available for payment",
  phInHouseService_NoOrderYet_Description: "There are no items on this table for payment yet. Please place an order first to use this feature.",
  phInHouseService_Button_Text: "You are logged in on",
  phInHouseService_Table: "Table {table_no}",
  phInHouseService_Group: "Ordering group {group}",
  phInHouseService_Guest: "Guest {seat_no}",
  phInHouseService_Items: "{items_count} Items",
  phInHauseService_Leave_Table_Dialog_Title: "Do you really want to leave the table?",
  phInHauseService_Leave_Table_Content: "Not all items have been paid for or there are items in the shopping basket that have not yet been ordered. Do you really want to leave the table?",
  phInHauseService_Leave_Table_Dialog_Button: "Leave table",

  phInHouseOrderResult_ThankYouForYourVisit: "Thank you for your visit",
  phInHouseOrderResult_SuccessfullPayment: "Thank you for your visit, we have received your payment.",
  phInHouseOrderResult_SuccessfullPayment_SecondParagraph: "We look forward to welcoming you back soon.",
  phInHouseOrderResult_OpenItems: "There are still {items} unpaid items on your table, with a total of {total}.",
  phInHouseOrderResult_ToNoCOO: "To invoice",
  phInHouseOrderResult_ToTable: "To table overview",
  phInHouseOrderResult_ToTheHomescreen: "Back to the start screen",
  phInHouseOrderResult_YourPaymentWasCancelled: "Your payment was cancelled, please try again",
  phInHouseOrderResult_DoYouWantToContinue_TEXT: "Would you like to choose another payment method? Then select back to the check-out.",
  phInHouseOrderResult_PaymentCouldNotBeAccepted: "Sorry, your payment could not be accepted",
  phInHouseOrderResult_ThereWasAProblem_TEXT: "Apparently there were problems with your payment, please try another payment method.",
  phInHouseOrderResult_FailedPaymentDialog_Title: "Payment failed",
  phInHouseOrderResult_FailedPaymentDialog_Text: "Sorry, your payment failed, please try again or contact our service staff.",
  phInHouseOrderResult_FailedPaymentDialog_Button: "Cancel",
  phInHouseOrderResult_Mandatory_Payment_Header: "Thanks for your order",
  phInHouseOrderResult_Mandatory_Payment_Info: "Your order on table number {table_no} has been received.",
  phInHouseOrderResult_Mandatory_Payment_PayAtWaiter: "Please pay at the cash register, by showing the QR-Code. After the payment, your order will be confirmed.",
  phInHouseOrderResult_AnnounceDialog_PayAtWaiter_Title: "Payment still pending",
  phInHouseOrderResult_AnnounceDialog_PayAtWaiter_Content: "Payment at the cash register still pending. You need the QR code to finalise the order. Have you already paid and want to go to the start screen?",
  phInHouseOrderResult_AnnounceDialog_PayAtWaiter_StayBtn: "Back",
  phInHouseTableClose_Title: "Close table",
  phInHouseTableClose_Content: "You are about to close the table. If other people have not ordered yet, they will be logged out and the table will be closed.",
  phInHouseTableClose_Btn_Confirm: "Continue payment",
  phInHouseTableClose_Btn_Cancel: "Cancel",

  phAgeDialog_Title: "Age rating only from {age} years!",
  phAgeDialog_Note: "You hereby confirm that You are at least the age specified above and are permitted to order this item.",
  phAgeDialog_Confirm_Btn: "Yes, I have reached the above age.",
  phAgeDialog_Deny_Btn: "No, I have not yet reached the age above.",
  phAgeDialog_Notice: "We reserve the right to carry out an age check.",

  phLocation_Required_Dialog_Title: "Location required",
  phLocation_Required_Dialog_Sub_Text: "Please enable your phone's location feature to proceed with the order.",
  phLocation_Dialog_Distance_Title: "Aren't you in our restaurant?",
  phLocation_Dialog_Distance_Sub_Text: "You do not seem to be in our location, please use another order type.",
  phLocation_Required_Dialog_Button: "Close",

  phInHouse_Payment_Select_Btn: "Select",
  phInHouse_Payment_Select_All: "Select all",
  phInHouse_Payment_Select_Own_Items: "Select my own",
  phInHouse_Payment_Select_None: "Deselect all",
  phPayment_Tab_Order_Overview: "Order overview",
  phPayment_Tab_Order_Data: "Customer data",
  phPayment_Tab_Order_Pay: "Payment",
  phInHouse_Payment_User_Place: "Place {placeNo}",
  phInHouse_Payment_Table: "Table",

  phInHouseLocalBasket_Table_Number: "Table:",
  phInHouseLocalBasket_Guest_Label: "Guest",
  phInHouseLocalBasket_User_Place: "Place {placeNo}",
  phInHouseLocalBasket_Order_Overview: "Table overview",
  phInHouseLocalBasket_Order_List_total: "Total",
  phInHouseLocalBasket_Ordered_Just_Now: "just now",
  phInHouseLocalBasket_Ordered_At: "{min} minutes ago",
  phInHouseLocalBasket_ImpressumDialog: "Impressum",
  phInHouseLocalBasket_ImpressumDialog_stnr: "Tax ID:",
  phInHouseLocalBasket_ImpressumDialog_ustid: "VAT ID",
  phInHouseLocalBasket_ImpressumDialog_commercial_register: "Commercial register:",
  phInHouseLocalBasket_ImpressumDialog_commercial_telephone: "Phone:",
  phInHouseLocalBasket_ImpressumDialog_local_court: "District Court:",
  phInHouseLocalBasket_ImpressumDialog_representative: "Authorized representative:",

  phInHouse_Sort_Option_Added: "Ordering time",
  phInHouse_Sort_Option_Menucourse: "Menu course",
  phInHouse_Sort_Option_Name: "Item description",
  phInHouse_Sort_Option_Price_Ascending: "Price (ascending)",
  phInHouse_Sort_Option_Price_Descending: "Price (descending)",
  phInHouse_Sort_Option_Place: "Place",

  phInHouse_Payment_Header: "Order overview",
  phInHouse_Payment_SubText: "Table {tableNr}",
  phInHouse_Payment_No_Assignment: "Without assignment",

  phInHouse_Continue_Btn: "Continue",
  phInHouse_Order_Confirm_HTML: "Your order on table number {table_no} has been received and will be prepared shortly.",

  phInHouse_Item_Not_Avaliable_Header: "Item is already paid",
  phInHouse_Item_Not_Avaliable_Subtext: "This item is already paid and can not be selected again.",
  phInHouse_Item_Not_Avaliable_Btn: "Close",

  phInHouse_NoConnection_Title: "No connection to the restaurant",
  phInHouse_NoConnection_Description: "Due to a technical problem, unfortunately, could not connect to the restaurant. Please try again later.",
  phInHouse_LostConnection_Title: "Lost connection to the restaurant",
  phInHouse_LostConnection_Description: "Sorry, the connection to the restaurant was interrupted. Please scan the table code again.",
  phInHouse_TableClosed_Title: "The table was closed",
  phInHouse_TableClosed_Description: "Your table has already been paid for and closed. Please scan a table code if you want to place a new order.",
  phInHouse_Cancel_Btn: "Cancel",
  phInHouse_Accept_Btn: "Confirm",

  phInHouse_Still_There_Title: "Are you still there?",
  phInHouse_Still_There_Description: "We have reset your item selection due to inactivity, please retry your payment process.",

  phInHouse_ItemsInBasket_Title: "You still have items in your shopping cart",
  phInHouse_ItemsInBasket_Description: "You have items in your shopping cart that you haven't ordered yet, do you want to discard them and pay now?",

  phInHouse_Reconnect_Dialog_Title: "Connection lost",
  phInHouse_Reconnect_Dialog_Info: "The Internet connection has been disconnected",
  phInHouse_Reconnect_Dialog_Info_Reconnect: "We try to reconnect",

  phInHouse_Discount_Title: "Discount not possible",
  phInHouse_Discount_Info: "Unfortunately, your stored discount cannot be used in this order type. Please contact our service staff.",
  phInHouse_Voucher_Info: "Unfortunately, the discount on your voucher cannot be used in this order type. Please make the payment to our service staff to get your discount.",

  phInHouse_Table_Overview_Empty_Title: "There are no orders yet",
  phInHouse_Table_Overview_Empty_Desc: "As soon as something is ordered on this table, you can see the table overview here",

  phContinueShoppingDialog_Label: "Article added to shopping cart",
  phContinueShoppingDialog_Button_Continue: "Continue shopping",
  phContinueShoppingDialog_Button_End: "To the shopping cart",

  phGroupOrder_Forward_Btn: "Forward",
  phInHouse_UseName_Request_Title: "Please tell us your name",
  phInHouse_UseName_Request_Desc: "Please enter your name so we can better assign your table orders",
  phInHouse_UseName_Request_InputPh: "Please enter your name",

  phContinueShoppingDialog_Label_IHGroup: "Select order options",
  phContinueShoppingDialog_Button_IHGroup_AddToGroupBasket: "Add to group cart",
  phContinueShoppingDialog_Button_IHGroup_orderDirectly: "Order now",
  phContinueShoppingDialog_Button_IHGroup_Overview: "Group overview",

  phNotification_Dialog_Title: " Notification",
  phNotification_Dialog_Content: "We will notify you via your browser when your order is ready for pickup.",
  phNotification_Dialog_DiscardContent: "If we are not allowed to notify you, you can cancel your order here.",
  phNotification_Dialog_DiscardContent_IHGroup: "If we are not allowed to notify you, you can cancel your order here",
  phNotification_Dialog_Annotation: "* Please also confirm the message from your browser or operating system.",
  phNotification_Dialog_AcceptButton: "Yes, gladly",
  phNotification_Dialog_DiscardTitle: "No notification",
  phNotification_Dialog_DiscardButton: "Discard order",
  phNotification_Dialog_DiscardButton_IHGroup: "Discard order",

  phNotificateVieSMS_Dialog_Title: "Sorry, unfortunately that didn't work out.",
  phNotificateVieSMS_Content: "Unfortunately, the activation of the notification did not work.",
  phNotificateVieSMS_RequestContent: "Please enter your cell phone number so we can text you when your order is ready for pickup.",
  phNotificateVieSMS_AcceptButton: "Notify via SMS",
  phNotificateVieSMS_Annotation: "*Your mobile number will only be used for this notification and will be deleted afterwards.",

  phInHouse_WrongCode_Title: "Wrong table code",
  phInHouse_WrongCode_Description: "Sorry, you did not scan a table code, please try again or contact our service staff.",
  phInHouse_WrongCode_Button: "Back",

  phInHouse_No_Notification: "You have not enabled notifications yet.",
  phInHouse_Push_Notification: "We will notify you as soon as your order is ready for pickup.",
  phInHouse_SMS_Notification: "We will send you an SMS to {phoneNumber} when your order is ready to be picked up.",
  phInHouse_SMS_Notification_Change_Number: "Change number",

  phGroupOrder_WrongCode_Title: "Wrong group code",
  phGroupOrder_WrongCode_Description: "Sorry, you did not scan a group code, please try again. The group code will be displayed to all group members via the Invite Friends feature.",
  phGroupOrder_WrongCode_Button: "Back",

  phGroupOrder_OrderNowDialog_Title: "Order now",
  phGroupOrder_OrderNowDialog_Content: "Do you really want to send your order right away and not order together with your friends?",
  phGroupOrder_OrderNowDialog_AcceptButton: "Order now",
  phGroupOrder_OrderNowDialog_DenyButton: "Cancel",

  phGroupOrder_SendOrderDialog_Title: "Send group order?",
  phGroupOrder_SendOrderDialog_Description: "Are you sure you want to place the group order for all group participants now?",
  phGroupOrder_SendOrderDialog_AcceptBtn: "Yes, order now",
  phGroupOrder_SendOrderDialog_DenyBtn: "No, return to group view",

  phBasketPay_OptionDialog_Title: "How would you like to pay?",
  phBasketPay_OptionDialog_Description: "Please choose whether you would like to pay at the till or digitally by smartphone.",
  phBasketPay_OptionDialog_PayWaiterBtn: "Pay at the checkout",
  phBasketPay_OptionDialog_PayOnlineBtn: "Pay digital on your smartphone",
  phBasketPay_WaiterDialog_Title: "Pay at the checkout",
  phBasketPay_WaiterDialog_Description: "Thank you for your selection, please pay directly at the checkout.",
  phBasketPay_OptionDialog_Back_Btn: "Return to the table",
  phBasketPay_ErrorDialog_Title: "Sorry, unfortunately an error has occurred",
  phBasketPay_ErrorDialog_Description: "Unfortunately we could not process your payment request.<br>Please try again later.",
  phBasketPay_ErrorDialog_Dialog_Button: "Back",

  phGroupOrder_Landingpage_Title: "Ordering group {groupname}",
  phGroupOrder_Landingpage_Creator: "from {creator}",
  phGroupOrder_Landingpage_BasketTitle: "Current group shopping cart",
  phGroupOrder_Landingpage_EmptyBasketContent: "No items selected",
  phGroupOrder_Landingpage_BasketContent: "items worth",
  phGroupOrder_Landingpage_SendGroupOrder_Btn: "Send group order",
  phGroupOrder_Landingpage_LeaveGroupOrder_Btn: "Leave group",

  phGroupOrder_NoOrderYet_Description: "There are no items in this order group for payment yet. Please place an order first to use this feature.",

  phGroupOrder_LeaveTable_Dialog_Title: "Do you really want to leave the order group?",
  phGroupOrder_LeaveTable_Dialog_Content: "Not all items have been paid for yet or there are items in the group shopping cart that have not yet been ordered. Do you really want to leave the order group?",
  phGroupOrder_LeaveTable_Dialog_Button: "Leave the group",

  phGroupOrder_Button_Text: "You are a member of the order group",

  phGroupOrder_Continue_Btn: "Continue",
  phGroupOrder_Continue_to_Basket_Btn: "Order",
  phGroupOrder_Create_GroupNameInput_PlaceHolder: "Custom name",
  phGroupOrder_Input_Validate_Length: "Please enter at least 3 letters",
  phGroupOrder_Input_Validate_Forbbiden: "Unacceptable group name",
  phGroupOrder_Input_Validate_Empty: "The group name cannot be empty",
  phGroupOrder_Input_Validate_Characters: "Please do not use special characters",
  phGroupOrder_Input_Validate_Name: "The name can not be empty.",
  phGroupOrder_Input_Validate_Forbbiden_UserName: "Unacceptable name",

  phGroupOrder_CreateGroup_Header: "Create new group order",
  phGroupOrder_CreateGroup_Subtext: "Please choose a name for your group",
  phGroupOrder_CreateGroup_Input_Info: "... or enter your own group name",
  phGroupOrder_CreateGroup_JoinGroup_Info: "... or join an existing order group",
  phGroupOrder_CreateGroup_JoinGroup_Header: "Join",
  phGroupOrder_CreateGroup_JoinGroup_Desc: "here you can join an existing order group",
  phGroupOrder_CreateGroup_Failed_Title: "Order group creation failed",
  phGroupOrder_CreateGroup_Failed_SubText: "Unfortunately, there was an error creating your order group, please try again in a few minutes.",
  phGroupOrder_CreateGroup_GroupName_Failed_Title: "Groupname already in use",
  phGroupOrder_CreateGroup_UserName_Failed_Title: "Username already in use",
  phGroupOrder_CreateGroup_Name_Failed_SubText: "Sorry, the name you entered is already in use, please use another name.",
  phGroupOrder_CreateGroup_Create: "Create Group",
  phGroupOrder_CreateGroup_Join_Btn: "Join",

  phGroupOrder_GroupCreated_Header: "Order group successfully created!",
  phGroupOrder_GroupCreated_Info: "You have successfully created the {groupName} group.",
  phGroupOrder_GroupCreated_State_Info: "The group icon in the title bar allows you to view the status of your group at any time.",
  phGroupOrder_GroupCreated_UserName_Input_Info: "Please enter your name so that we can correctly assign your order.",
  phGroupOrder_GroupCreated_UserName_Input_placeholder: "Enter guest name",
  phGroupOrder_GroupCreated_Invite_Friends_Info: "Invite your friends to this ordering group to place a joint order and enjoy your meal together",
  phGroupOrder_GroupCreated_Invite_Btn: "Invite now",
  phGroupOrder_GroupCreated_Without_Invite_Btn: "Continue without invitation",

  phGroupOrder_GroupMaxCount_Dialog_Title: "Unfortunately, no order group could be created.",
  phGroupOrder_GroupMaxCount_Dialog_SubText: "Unfortunately, the maximum number of order group for this table has already been reached. Please use another table code or place a single order.",

  phGroupOrder_InviteFriends_Dialog_Title: "Don't you want to invite friends?",
  phGroupOrder_InviteFriends_Dialog_SubText: "Do you really want to order now without inviting your friends first?  With a group order you can get your food at the same time and enjoy it together.",
  phGroupOrder_InviteFriends_Dialog_OrderBtn: "Order",
  phGroupOrder_InviteFriends_Dialog_OrderNowBtn: "Order now",
  phGroupOrder_InviteFriends_Dialog_InviteBtn: "Invite friends",

  phGroupOrder_LinkExpired_Title: "Unfortunately the group has expired",
  phGroupOrder_LinkExpired_SubText: "Sorry, this order group has expired, please create a new group or place an individual order.",
  phGroupOrder_LinkExpired_Btn: "New order",

  phGroupOrder_Share_Title: "Invite friends",
  phGroupOrder_Share_SubText: "Invite your friends to this group to place a joint order and enjoy together.",
  phGroupOrder_Share_Link_Info: "Send your friends a link via Whatsapp & Co",
  phGroupOrder_Share_Link_Btn: "Share Link",
  phGroupOrder_Share_Link_NotAvailable_Title: "Sharing failed",
  phGroupOrder_Share_Link_NotAvailable_Subtext: "Unfortunately, sharing does not seem to work on your device. You can still send the invitation to your friends via the 'Copy link' button by pasting the link into Whatsapp & Co and sending it.",
  phGroupOrder_Share_Link_Copy_Btn: "Copy link",

  phGroupOrder_Invite_QRCode_Title: "Via QR-Code",
  phGroupOrder_Invite_QRCode_Info: "Let your friends scan the following group code so they can join the order group",
  phGroupOrder_Invite_Btn: "Scan QR-Code",

  phGroupOrder_Invitation_Recieved_Title: "Welcome to the {groupName} order group of {userName}",
  phGroupOrder_Invitation_Recieved_SubText: "Please enter your first name so that we can correctly assign your order.",
  phGroupOrder_Invitation_Recieved_input: "Please enter your name",
  phGroupOrder_Invitation_Recieved_Join_Btn: "Join",
  phGroupOrder_Invitation_Recieved_Deny_Btn: "Decline",

  phGroupOrder_QRCode_Scanner_Title: "Join an order group",
  phGroupOrder_QRCode_Scanner_SubText: "Please scan a group code to join an order group of your friends. The group code will be displayed to all group members via the Invite Friends feature.",
  phGroupOrder_QRCode_Scanner_NoCam_Info: "If you don't have a camera and can't scan the group code, ask your friends to share a group invitation via link",

  phGroupOrder_MaxMemberCount_Title: "No joining possible",
  phGroupOrder_MaxMemberCount_SubText: "Unfortunately, joining is no longer possible because the maximum group size has already been reached. Please create a new order group or place an individual order.",

  phGroupOrder_LocationClosed_Title: "No joining possible",
  phGroupOrder_LocationClosed_SubText: "Unfortunately, joining is no longer possible because it looks like we are closed right now. Please note our opening hours.",

  phGroupOrder_GroupOverview_Title: "Order group {groupName} from {groupCreatorName}",
  phGroupOrder_GroupOverview_UserList_Basket: "In basket",
  phGroupOrder_GroupOverview_UserList_Ordered: "Ordered",
  phGroupOrder_GroupOverview_Basket_Title: "Current group basket",
  phGroupOrder_GroupOverview_Basket_Info: "items worth",
  phGroupOrder_GroupOverview_Basket_NoOrder_Title: "No items selected",
  phGroupOrder_GroupOverview_Basket_PlaceGroupOrder_Btn: "Send group order",

  phGroupOrder_MemberOrder_Detail_Label: "Order overview of",
  phGroupOrder_MemberOrder_Detail_Basket_Label: "Items in group basket",
  phGroupOrder_MemberOrder_Detail_Ordered_Label: "Ordered items",
  phGroupOrder_MemberOrder_Detail_ApplyChange_Btn: "Apply change",
  phGroupOrder_MemberOrder_Detail_PayNow_Btn: "Pay now",
  phGroupOrder_MemberOrder_Detail_Total_Label: "Total",
  phGroupOrder_MemberOrder_Detail_Empty_Basket: "No items in group basket",
  phGroupOrder_MemberOrder_Detail_Empty_Order: "No orders available",
  phGroupOrder_MemberOrder_Detail_OrderNow_Btn: "Order now",
  phGroupOrder_MemberOrder_Detail_State_Preparation: "in preparation",
  phGroupOrder_MemberOrder_Detail_State_Pickup: "ready for pickup",
  phGroupOrder_MemberOrder_Detail_State_PickedUp: "picked up",

  phGroupOrder_Payment_Group: "Order group",

  phGroupOrder_Confirm_HTML: "Your order for order group {group_name} has been received and will be prepared shortly",
  phGroupOrder_PaymentResult_GroupBtn: "To Group overview",

  phGroupOrder_UserIsAlready_Member_Title: "Not possible to join",
  phGroupOrder_UserIsAlready_Member_SubText: "You are already a member of an order group. Please go to 'Leave order group' before you can join another order group.",

  phPhoneInput_Min_Error: "Please enter at least 6 digits.",
  phPhoneInput_Max_Error: "Please enter a maximum of 16 digits.",
  phPhoneInput_NumbersOnly_Error: "Please enter numbers only.",

  phChangePhoneNumber_Title: "Edit phone number",
  phChangePhoneNumber_SubText: "Here you can change your phone number {phoneNumber} for the notification. Please note that notifications that have already been sent will not be sent again.",
  phChangePhoneNumber_Btn_Label: "Applay",

  phChangePhoneNumber_Failed_Title: "Sorry, unfortunately an error has occurred",
  phChangePhoneNumber_Failed_Desc: "Unfortunately we could not process the change of your call number, please try again in a few minutes.",

  phCoupon_Redeem_Title: "Redeem coupons",
  phCoupon_Redeem_Description: "Here you can redeem our coupons directly in the webshop.",
  phCoupon_Redeem_AppCoupon_Title: "Select coupon",
  phCoupon_Redeem_Show_All: "Show all",
  phCoupon_Redeem_Btn_Label: "Redeem Coupon",
  phCoupon_Redeem_Scan_Title: "Scan coupon code",
  phCoupon_Redeem_Scan_Btn_Text: "Scan now",
  phCoupon_Redeem_Scan_Btn_Text_Cancel: "Cancel",
  phCoupon_Redeem_Input_Title: "Enter coupon code",
  phCoupon_Redeem_Input_Placeholder: "{requiredLength}- digit coupon code",
  phCoupon_Redeem_Error_MinLength: "Please enter at least {requiredLength} digits.",
  phCoupon_Redeem_Error_MaxLength: "Please enter a maximum of {requiredLength} digits.",
  phCoupon_Redeem_Error_NumbersOnly: "Please enter numbers only.",
  phCoupon_Redeem_OrderType_Not_Valid_Title: "Order type invalid",
  phCoupon_Redeem_OrderType_Not_Valid_SubText: "Unfortunately, coupons cannot be redeemed for your selected order type, please select another order type.",
  phCoupon_Redeem_OrderType_Not_Valid_Change_Btn: "Change order type",
  phCoupon_Redeem_OrderType_Not_Valid_Cancel_Btn: "Cancel",
  phCoupon_Redeem_Code_Not_Valid_Title: "Coupon invalid",
  phCoupon_Redeem_Code_Not_Valid_SubText: "Unfortunately, the coupon code is invalid or not available at the selected location. Please use a different coupon code.",
  phCoupon_Redeem_Cannt_Redeem_Code_SubText: "Unfortunately, the coupon code is invalid. Please use a different coupon code.",
  phCoupon_Redeem_Product_Not_Available_Title: "Coupons not redeemable",
  phCoupon_Redeem_Product_Not_Available_SubText: "Unfortunately, the coupon code cannot currently be redeemed. Please try again tomorrow. ",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Title: "Where would you like to redeem your coupon?",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Tab_location_Label: "Locations",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Tab_Location_Desc: "Please select a location to redeem your coupon",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Tab_OrderType_label: "Order type",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Tab_OrderType_Desc: "How would you like to redeem the coupon with us?",
  phCoupon_Redeem_LocationAndOrderType_Dialog_Tab_OrderType_Empty: "Unfortunately, the selected coupon cannot be redeemed at this location. Please try another coupon.",
  phCoupon_Redeem_Table_Login_Required_Dialog_Title: "Table code required",
  phCoupon_Redeem_Table_Login_Required_Dialog_Desc: "Please scan a table code first before you can redeem the coupon.",
  phCoupon_State_AlreadyRedeemed: "Already redeemed",
  phCoupon_State_InCart: "In cart",
  phCoupon_Redeem_Error_AlreadyRedeemed: "This coupon has already been redeemed and cannot be used again.",
  phCoupon_Redeem_Error_AlreadyRedeemed_Title: "Coupon already redeemed",
  phCoupon_InCart_Dialog_Title: "Coupon already in your cart",
  phCoupon_InCart_Dialog_Text: "This coupon has already been added and will be redeemed automatically when you complete your order. It can only be redeemed once.",
  phCoupon_InCart_Dialog_ToCart: "Go to cart",
  phCoupon_InCart_Dialog_Back: "Back",
  phCoupon_BasketLine_Label: "Coupon",

  phUpdate_App_Optionally_Dialog_Header: "Update available",
  phUpdate_App_Optionally_Dialog_Description: "The new version {versionsNummer} is available in the Store",
  phUpdate_App_Optionally_Dialog_Btn_Update: "Update",

  phUpdate_App_Forced_Dialog_Header: "Update necessary",
  phUpdate_App_Forced_Dialog_Description: "Please update to the latest version {versionsNummer} to keep using our App",
  phUpdate_App_Forced_Dialog_Btn_Update: "Update",

  phTimeCotrolDialog_Info_Items: "Products outside the order time",
  phTimeCotrolDialog_Description: "Unfortunately, one or more products cannot be ordered for the selected time. Please note the order times indicated in each case.",
  phTimeCotrolDialog_Scheduled_info_Order_Time: "OrderTime time until:",
  phTimeCotrolDialog_Scheduled_info_AnotherDay_Order_Time: "Order time {fromTime} - {toTime}",
  phTimeCotrolDialog_No_Order_Possible_For_Selected_Time: "No order possible at {time}",
  phTimeCotrolDialog_No_Order_Possible_For_Selected_Day: "Order not possible on selected day",
  phTimeCotrolDialog_Button_Remove_item: "Remove products",
  phTimeCotrolDialog_Button_Change_Time: "Change order time",

  phAddress_Required_Header: "Hey, we need your address to be able to display restaurants in your area.",
  phAddress_Required_Alternative_Addresses: "Your alternative delivery addresses",

  phChargeVoucherDialog_Change_Price_Title: "Change Recharge Amount",
  phChargeVoucherDialog_Change_Price_Info: "Should the current recharge amount of {currentAmount} be replaced with {newAmount}?",
  phChargeVoucherDialog_Change_Price_Confirm: "Yes, replace",
  phChargeVoucherDialog_Change_Price_Decline: "No, keep",

  phRemoteOrder_DefineName_Title: "Create New Group Order",
  phRemoteOrder_DefineUserName_Info: "Please enter your name:",
  phRemoteOrder_DefineGroupName_Info: "Please enter a name for your group:",
  phRemoteOrder_DefineUserName_Info_PlaceHolder: "Username",
  phRemoteOrder_DefineGroupName_Info_PlaceHolder: "Group Name",

  phRemoteOrder_Input_Validate_Name_required: "The name cannot be empty",
  phRemoteOrder_Input_Validate_Name_minlength: "Please enter at least 3 characters",
  phRemoteOrder_Input_Validate_Name_pattern: "Please do not use special characters",
  phRemoteOrder_Input_Validate_Name_forbiddenName: "Invalid name",

  phRemoteOrder_GroupName_display_label: "{username}'s Group",

  phRemoteOrder_DefineTime_Title: "Please enter the desired times for your group order.",
  phRemoteOrder_DefineTime_SeviceTime_Delivery_Info: "Select the desired delivery time.",
  phRemoteOrder_DefineTime_SeviceTime_Pickup_Info: "Select the desired pickup time.",
  phRemoteOrder_DefineTime_Sevice_Pickup_Day_Label: "Takeaway day",
  phRemoteOrder_DefineTime_Sevice_Pickup_Time_Label: "Takeaway time",
  phRemoteOrder_DefineTime_Sevice_Delivery_Day_Label: "Delivery day",
  phRemoteOrder_DefineTime_Sevice_Delivery_Time_Label: "Delivery time",

  phRemoteOrder_DefineTime_Order_Title: "Set order deadline",
  phRemoteOrder_DefineTime_Order_Info: "When should all group members have submitted their orders?",
  phRemoteOrder_DefineTime_Order_Notice: "Please ensure the lead time is at least {minutes} minutes.",
  phRemoteOrder_DefineTime_Order_Day: "Order day:",
  phRemoteOrder_DefineTime_Order_Time: "Order time:",

  phRemoteOrder_Dialog_GroupMaxCountReached_Title: "Maximum Number Reached",
  phRemoteOrder_Dialog_GroupMaxCountReached_Info: "Unfortunately, we have currently reached the maximum number of order groups. You can place an individual order or try again later.",
  phRemoteOrder_Dialog_GroupFail_Title: "Group Order Creation Failed",
  phRemoteOrder_Dialog_GroupFail_Info: "Unfortunately, there was an error creating your group order. Please try again in a few minutes.",
  phRemoteOrder_Dialog_Time_Conflict_Title: "Adjust Time",
  phRemoteOrder_Dialog_Time_Conflict_Info: "Unfortunately, a group order cannot be made for the selected time. Please change the time and try again.",
  phRemoteOrder_Dialog_Time_Conflict_TooSoon_Info: "Please note that the lead time must be at least {minutes} minutes. Choose a later time.",
  phRemoteOrder_Dialog_Time_Conflict_button_label: "Change time",

  phRemoteOrder_GroupCreate_Confirm_Title: "{groupName} group has been successfully created",
  phRemoteOrder_GroupCreate_Confirm_Nav_Info: "You can check the status of your group at any time via the group icon in the title bar.",
  phRemoteOrder_GroupCreate_Confirm_Pay_Info: "Please remember that as the group creator, you are responsible for the total payment.",
  phRemoteOrder_GroupCreate_Confirm_Invite_Info: "Invite your friends to this order group to place a joint order and enjoy your meal together.",
  phRemoteOrder_GroupCreate_Confirm__Invite_Btn: "Invite now",

  phRemoteOrder_Without_Invite_Btn: "Continue without invitation",
  phRemoteOrder_Invite_OrderBtn: "Order now",

  phRemoteOrder_Share_Title: "Invitation to Group Order",
  phRemoteOrder_Share_SubText: "Share the group link with your friends, colleagues, or family members via WhatsApp, email, and more.",
  phRemoteOrder_share_Link: "Share Link",

  phRemoteOrder_MaxMemberCount_Dialog_Title: "No further invitations possible",
  phRemoteOrder_MaxMemberCount_Dialog_SubText: "The maximum number of members for this group has been reached.",

  phRemoteOrder_Confirm_Invite_Dialog_Title: "Don't you want to send an invitation?",
  phRemoteOrder_Confirm_Invite_Dialog_SubText: "Are you sure you want to order now without sending invitations? With a group order, you can enjoy your meal together.",
  phRemoteOrder_Confirm_Invite_Dialog_OrderBtn: "Order",
  phRemoteOrder_Confirm_Invite_Dialog_InviteBtn: "Invite",

  phRemoteOrder_Group_Servicepage_Title: "Ordering group {groupname}",
  phRemoteOrder_Group_Servicepage_Creator: "from {creator}",
  phRemoteOrder_Group_Servicepage_BasketTitle: "Current group shopping cart",
  phRemoteOrder_Group_Servicepage_EmptyBasketContent: "No items selected",
  phRemoteOrder_Group_Servicepage_BasketContent: "items worth",
  phRemoteOrder_Group_Servicepage_LeaveGroup: "Leave group",
  phRemoteOrder_Group_Servicepage_Order: "Order",
  phRemoteOrder_Group_Servicepage_Order_description: "Navigate to menu.",
  phRemoteOrder_Group_Servicepage_ViewGroup: "My order group",
  phRemoteOrder_Group_Servicepage_ViewGroup_description: "View group overview.",
  phRemoteOrder_Group_Servicepage_Pay: "Pay",
  phRemoteOrder_Group_Servicepage_Pay_description: "Pay and complete group order.",
  phRemoteOrder_Group_Servicepage_SendGroupOrder: "Send group order",

  phRemoteOrder_Group_Delivery_Address_To: "Group delivery address: {groupaddress}",
  phRemoteOrder_Group_Delivery_Time: "Delivery time: {day} at {time}",
  phRemoteOrder_Group_Delivery_Time_Today: "Delivery: today at {time}",
  phRemoteOrder_Group_Delivery_From: "From: {locationname}",
  phRemoteOrder_Group_Pickup_Address: "Pickup at this address:",
  phRemoteOrder_Group_Pickup_Time: "Pickup time: {day} at {time}",
  phRemoteOrder_Group_Pickup_Time_Today: "Pickup: today at {time}",
  phRemoteOrder_Group_End_Time: "Order: on {day} by {time}",
  phRemoteOrder_Group_End_Time_Today: "Order: today by {time}",
  phRemoteOrder_Group_Set_State_Ready: "Your order status:",
  phRemoteOrder_Group_Member_State: "Order status: ",
  phRemoteOrder_Group_Member_State_Ready: "Ready",

  phRemoteOrder_Payment_Group: "Order group",

  phRemoteOrder_Home_Button_Text: "You are a member of the order group",
  phRemoteOrder_Home_Button_Items: "{items_count} Items",
  phRemoteOrder_Home_Button_Info: "Order completed! ",
  phRemoteOrder_Home_Button_Info_View_Details: "View details.",

  phRemoteOrder_Entry_Title: "Welcome to the {groupName} order group of {userName}",
  phRemoteOrder_Entry_SubText: "Please enter your first name so that we can correctly assign your order.",
  phRemoteOrder_Entry_input: "Please enter your name",
  phRemoteOrder_Entry_Join_Btn: "Join",
  phRemoteOrder_Entry_Deny_Btn: "Decline",

  phRemoteOrder_ContinueOrder_Label: "Item added to group basket",
  phRemoteOrder_ContinueOrder_State_Info: "If you're done with your order, complete the order and go to the group basket.",
  phRemoteOrder_ContinueOrder_Btn_Continue: "Continue shopping",
  phRemoteOrder_ContinueOrder_Btn_Cart: "Complete order",

  phRemoteOrder_SendOrderDialog_Title: "Send group order?",
  phRemoteOrder_SendOrderDialog_Description: "Are you sure you want to place the group order for all group participants now?",
  phRemoteOrder_SendOrderDialog_Description_StateReady: "Are you sure you want to place the group order for all group participants now? Note that not all members have set their status to 'Ready'.",
  phRemoteOrder_SendOrderDialog_AcceptBtn: "Yes, order now",
  phRemoteOrder_SendOrderDialog_DenyBtn: "No, return to group view",

  phRemoteOrder_PayResult_Title: "Order Completed",
  phRemoteOrder_PayResult_Info: "The group order has been successfully completed!",

  phRemoteOrder_ChangeOrder_Dialog_Title: "Do you really want to leave the group?",
  phRemoteOrder_ChangeOrder_Dialog_Content: "To select a different order type, you must first leave the group.",
  phRemoteOrder_ChangeOrder_Dialog_Button: "Leave group",

  phRemoteOrder_Creator_Closed_Group_Dialog_Title: "Group has been ended",
  phRemoteOrder_Creator_Closed_Group_Dialog_Content: "The group creator has left the group. Therefore, the group has been ended. You can place an individual order or create a new group.",

  phRemoteOrder_Member_Leave_Group_Dialog_Title: "Do you really want to leave the group?",
  phRemoteOrder_Member_Leave_Group_Dialog_Content: "Please note that all your items in the group cart may be deleted if you proceed.",
  phRemoteOrder_Member_Leave_Group_Dialog_Button: "Leave group",

  phRemoteOrder_Creator_Leave_Group_Dialog_Title: "Do you really want to leave and end the group?",
  phRemoteOrder_Creator_Leave_Group_Dialog_Content: "Please note that you are the group creator.If you leave the group, it will be closed.",
  phRemoteOrder_Creator_Leave_Group_Dialog_Button: "Leave group",

  phRemoteOrder_PaymentStarted_NoOrderPossible_Title: "Payment in Progress",
  phRemoteOrder_PaymentStarted_NoOrderPossible_Info: "The group cart is currently being paid for. No additional products can be added.",

  phRemoteOrder_MemberOrder_Detail_Owner_Label: "Your order overview",
  phRemoteOrder_MemberOrder_Detail_Guest_Label: "Order overview of {name}",
  phRemoteOrder_MemberOrder_Detail_Basket_Label: "items worth",
  phRemoteOrder_MemberOrder_Detail_Empty_Basket: "No items in the group cart",

  phRemoteOrder_Change_Service_Time_Title: "How the time flies...",
  phRemoteOrder_Change_Service_Time_Info: "Your selected service time { selectedServiceTime } has unfortunately expired.Please select a new time.",
  phRemoteOrder_Change_Service_Time_Closed: "Unfortunately, we can no longer accept your order today.",
  phRemoteOrder_Change_Service_Time_Cancel_Btn: "Cancel",

  phRemoteOrder_Reminder_Title: "Time to Place Your Order",
  phRemoteOrder_Reminder_Info: "The order deadline ends in {time} minutes. Please make sure you have all the desired items in your cart.",

  phRemoteOrder_Group_Summary_Title: "Ordering group {groupname}",
  phRemoteOrder_Group_Summary_ServiceTime_Delivery: "Delivery time: {day} at {time}",
  phRemoteOrder_Group_Summary_ServiceTime_Today_Delivery: "Delivery: today at {time}",
  phRemoteOrder_Group_Summary_ServiceTime_Pickup: "Pickup time: {day} at {time}",
  phRemoteOrder_Group_Summary_ServiceTime_Today_Pickup: "Pickup: today at {time}",
  phRemoteOrder_Group_Summary_Basket_Title: "Group shopping cart",
  phRemoteOrder_Group_Summary_Basket_Items: "items worth",
  phRemoteOrder_Group_Summary_Status: "The group order has been successfully completed!",
  phRemoteOrder_Group_Summary_Delivery_Address_To: "Group delivery address: {groupaddress}",
  phRemoteOrder_Group_Summary_Delivery_From: "From {locationname}",
  phRemoteOrder_Group_Summary_Pickup_Address: "Pickup at this address: ",

  phTERMS_ACCESSIBILITY_TITLE: "Declaration of Accessibility",
  phTERMS_ACCESSIBILITY_SECTION1_TITLE: "1. Applicable Requirements",
  phTERMS_ACCESSIBILITY_SECTION1_TEXT: "The accessibility requirements for services are derived from the Accessibility Strengthening Act (BFSG), especially from § 14 BFSG in conjunction with § 3 para. 1 BFSG, as well as the regulation on the Accessibility Strengthening Act (BFSGV). Services are accessible if they can be found, accessed, and used by people with disabilities in the usual way, without particular difficulty and generally without outside help.",
  phTERMS_ACCESSIBILITY_SECTION2_TITLE: "2. Description of Service",
  phTERMS_ACCESSIBILITY_SECTION2_TEXT1: "Hypersoft Trading GmbH, based in Hamburg, develops modern POS systems for the hospitality industry. The company offers integrated solutions of software, hardware, and digital services that support all operational and guest services.",
  phTERMS_ACCESSIBILITY_SECTION2_TEXT2: "The service portfolio includes:",
  phTERMS_ACCESSIBILITY_SECTION2_LIST: ["Software solutions and POS systems: Scalable systems for ordering, payment, and process optimization.", "Webshops, Self Order Terminals, and Apps: Digital solutions for on-site or mobile ordering and payment.", "Consulting, sales, and support: Personal assistance, installation, training, and comprehensive documentation."],
  phTERMS_ACCESSIBILITY_SECTION3_TITLE: "3. Use of Our Digital Services",
  phTERMS_ACCESSIBILITY_SECTION3_TEXT: "We are committed to ensuring that our digital services—webshops, self-order terminals, and apps—are accessible. We follow the Web Content Accessibility Guidelines (WCAG) 2.1, conformance levels A and AA.",
  phTERMS_ACCESSIBILITY_SECTION4_TITLE: "4. Features of Accessibility",
  phTERMS_ACCESSIBILITY_SECTION4_TEXT1: "The accessibility requirements according to BFSG are found in the following three legal bases:",
  phTERMS_ACCESSIBILITY_SECTION4_LIST1: ["Accessibility Strengthening Act (BFSG)", "Regulation on accessibility requirements for products and services under the Accessibility Strengthening Act (BFSGV)", "Guidelines for accessible web content (WCAG)"],
  phTERMS_ACCESSIBILITY_SECTION4_TEXT2: "According to these legal bases, our offering must meet four principles of accessibility:",
  phTERMS_ACCESSIBILITY_SECTION4_LIST2: ["Perceptibility", "Operability", "Comprehensibility", "Robustness"],
  phTERMS_ACCESSIBILITY_SECTION4_SUBTITLE1: "Perceptibility",
  phTERMS_ACCESSIBILITY_SECTION4_SUBTITLE1_TEXT: "All informative content, whether in the webshop, apps, or self-order terminals, is provided with alternative texts and accessible presentations. We ensure sufficient color contrast and the ability to hide images. Font sizes can be increased in accessible mode. Animations can be reduced.",
  phTERMS_ACCESSIBILITY_SECTION4_SUBTITLE2: "Operability",
  phTERMS_ACCESSIBILITY_SECTION4_SUBTITLE2_TEXT: "The systems, including website, apps, and self-order terminals, are fully usable via keyboard, screen reader, or touch. Clear structure and understandable menus make navigation easier. All essential functions, especially ordering and payment, are available in accessible mode.",
  phTERMS_ACCESSIBILITY_SECTION4_SUBTITLE3: "Comprehensibility",
  phTERMS_ACCESSIBILITY_SECTION4_SUBTITLE3_TEXT: "We strive to provide our content in clear and understandable language. Full implementation according to language level B2 of the Common European Framework of Reference for Languages (CEFR) is still in progress. We continuously work to simplify our texts and make them more accessible to all users. Information can be read or read aloud by common assistive programs such as screen readers.",
  phTERMS_ACCESSIBILITY_SECTION4_SUBTITLE4: "Robustness",
  phTERMS_ACCESSIBILITY_SECTION4_SUBTITLE4_TEXT: "Our digital offerings (webshops, self-order terminals, and apps) are compatible with common assistive technologies. Implementation has been checked by self-assessment.",
  phTERMS_ACCESSIBILITY_SECTION5_TITLE: "5. Accessibility Status",
  phTERMS_ACCESSIBILITY_SECTION5_TEXT1: "Our webshops, self-order terminals, and smartphone apps are fully compliant with the requirements of the Accessibility Strengthening Act (BFSG) and the Web Content Accessibility Guidelines (WCAG) 2.1, conformance levels A and AA, in accessible mode.",
  phTERMS_ACCESSIBILITY_SECTION5_TEXT2: "In standard mode (without activating accessible mode), requirements are not fully met in all areas. The following barriers may occur:",
  phTERMS_ACCESSIBILITY_SECTION5_LIST1: ["Font sizes may be too small for users with visual impairments.", "Color contrasts do not always meet minimum requirements.", "Animations may be distracting for some users.", "Images may increase loading times or affect readability."],
  phTERMS_ACCESSIBILITY_SECTION5_TEXT3: "Full accessibility is ensured by activating accessible mode. This includes in particular:",
  phTERMS_ACCESSIBILITY_SECTION5_LIST2: ["Increasing font size", "Adjusting color contrasts", "Ability to hide images", "Reducing animations"],
  phTERMS_ACCESSIBILITY_SECTION5_TEXT4: "The following functions are always available:",
  phTERMS_ACCESSIBILITY_SECTION5_LIST3: ["Full keyboard and screen reader usability", "Alternative texts for images", "A fully accessible ordering process including payment, cancellation policy, and terms and conditions"],
  phTERMS_ACCESSIBILITY_SECTION5_TEXT5: "Accessibility of our offering is checked at least annually, and this statement is updated accordingly.",
  phTERMS_ACCESSIBILITY_SECTION6_TITLE: "6. NoCOO",
  phTERMS_ACCESSIBILITY_SECTION6_TEXT1: "Our digital offerings are complemented by the NoCOO system for digital invoices. Like our webshops and self-order terminals, NoCOO offers an accessible mode with the following features:",
  phTERMS_ACCESSIBILITY_SECTION6_LIST1: ["Increasing font size", "Adjusting color contrasts", "Ability to hide images", "Reducing animations"],
  phTERMS_ACCESSIBILITY_SECTION6_TEXT2: "The following functions are always available:",
  phTERMS_ACCESSIBILITY_SECTION6_LIST2: ["Full keyboard and screen reader usability", "Alternative texts for images"],
  phTERMS_ACCESSIBILITY_SECTION7_TITLE: "7. Feedback and Contact",
  phTERMS_ACCESSIBILITY_SECTION7_TEXT1: "If you notice any barriers or have questions about accessibility, we welcome your feedback. Please contact us at:",
  phTERMS_ACCESSIBILITY_SECTION7_CONTACT: "Hypersoft Trading GmbH\nAmtsstraße 9\n22143 Hamburg\nPhone: +49 (0) 40 66 905 - 100\nEmail: info@hypersoft.de\nWebsite: https://www.hypersoft.de",
  phTERMS_ACCESSIBILITY_SECTION8_TITLE: "8. Responsible Market Surveillance Authority",
  phTERMS_ACCESSIBILITY_SECTION8_CONTACT: "Free and Hanseatic City of Hamburg\nAuthority for Labour, Health, Social Affairs, Family and Integration\nOffice for Social Affairs – Market Surveillance Department BFSG\nHamburger Str. 47\n22083 Hamburg\nPhone: +49 40 42863-0\nEmail: poststelle@soziales.hamburg.de\nWebsite: https://www.hamburg.de/soziales",
  phExpiredEvent_Title: "Price Change",
  phExpiredEvent_Description_Single: "The price of one or more items in your cart has changed because the original special price is no longer available. Please check your order.",
  phExpiredEvent_Description_GroupOrder: "The price of one or more items in group order has changed because the original special price is no longer available. Please check your order.",

  phBasket_ServiceTime_Delivery: "Delivery time: {day} at {time}",
  phBasket_ServiceTime_Today_Delivery: "Delivery: today at {time}",
  phBasket_ServiceTime_ASAP_Today_Delivery: "today at {time}",
  phBasket_ServiceTime_Pickup: "Pickup time: {day} at {time}",
  phBasket_ServiceTime_Today_Pickup: "Pickup: today at {time}",
  phBasket_ServiceTime_ASAP_Today_Pickup: "today at {time}",

  phAGBConfirmationDialog_Title: "Terms and Conditions Confirmation",
  phAGBConfirmationDialog_Description: "To continue, please confirm the Terms and Conditions (T&C) and Privacy Policy once.",
  phAGBConfirmationDialog_AcceptBtn: "Accept",
  phAGBConfirmationDialog_DeclineBtn: "Decline",

  phRevokeOrder_FooterLink: "Withdraw order",
  phRevokeOrder_Tab1Title: "Withdraw order",
  phRevokeOrder_Tab2Title: "Confirmation",
  phRevokeOrder_Tab1Subtitle: "You can withdraw your contract here. Please provide the following information so we can clearly assign your withdrawal to your order.",
  phRevokeOrder_FieldName: "Name",
  phRevokeOrder_FieldEmail: "Email address for the confirmation",
  phRevokeOrder_FieldOrderNumber: "Order number",
  phRevokeOrder_OrderNumberHint: "You can find the number in your order confirmation email.",
  phRevokeOrder_FieldArticles: "Affected items",
  phRevokeOrder_FieldReason: "Reason for withdrawal",
  phRevokeOrder_Optional: "(optional)",
  phRevokeOrder_Tab2Headline: "Your withdrawal at a glance",
  phRevokeOrder_Tab2Subtitle: "Please review your details. Clicking the button below will submit your withdrawal with legal effect.",
  phRevokeOrder_ConfirmWarning: "By clicking 'Confirm withdrawal' you submit your declaration with legal effect. You will immediately receive a confirmation email.",
  phRevokeOrder_BtnConfirm: "Confirm withdrawal",
  phRevokeOrder_PostConfirmHint: "The validity of your withdrawal will subsequently be reviewed by the merchant.",
  phRevokeOrder_ErrorRequired: "This field is required.",
  phRevokeOrder_ErrorEmailFormat: "Please enter a valid email address.",
  phRevokeOrder_LabelName: "Name",
  phRevokeOrder_LabelEmail: "Email",
  phRevokeOrder_LabelOrderNumber: "Order number",
  phRevokeOrder_LabelArticles: "Items",
  phRevokeOrder_LabelReason: "Reason",
  phRevokeOrder_ResultSuccessHeadline1: "Thank you.",
  phRevokeOrder_ResultSuccessHeadline2: "Your withdrawal has been successfully submitted.",
  phRevokeOrder_ResultSuccessSubtext: "A confirmation has been sent to the email address you provided.",
  phRevokeOrder_ResultErrorHeadline: "Unfortunately, the confirmation could not be sent.",
  phRevokeOrder_ResultErrorSubtext: "Your withdrawal could not be submitted successfully. Please contact the provider directly. You can find the contact details in the legal notice (Impressum).",

  phAccountPayment_SectionLabel: "Account payment",
  phAccountPayment_ButtonRequestActivation: "Send request",
  phAccountPayment_ButtonChangePaymentMethod: "Change payment method",

  phWEBSHOP_ColorPreviewBanner: "Colour preview ({0}) – not the saved state",

  EOF: "EOF"
};
